// converted the graphql data from csv to json
const categories = [
  {
    categoryID: 1,
    categoryName: "Beverages",
    description: "Soft drinks coffees teas beers and ales",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 2,
    categoryName: "Condiments",
    description: "Sweet and savory sauces relishes spreads and seasonings",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 3,
    categoryName: "Confections",
    description: "Desserts candies and sweet breads",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 4,
    categoryName: "Dairy Products",
    description: "Cheeses",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 5,
    categoryName: "Grains/Cereals",
    description: "Breads crackers pasta and cereal",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 6,
    categoryName: "Meat/Poultry",
    description: "Prepared meats",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 7,
    categoryName: "Produce",
    description: "Dried fruit and bean curd",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
  {
    categoryID: 8,
    categoryName: "Seafood",
    description: "Seaweed and fish",
    picture:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E5069637475726500010500000200000007000000504272757368000000000000000000A0290000424D98290000000000005600000028000000AC00000078000000010004000000000000000000880B0000880B0000080000",
  },
];
const customers = [
  {
    customerID: "ALFKI",
    companyName: "Alfreds Futterkiste",
    contactName: "Maria Anders",
    contactTitle: "Sales Representative",
    address: "Obere Str. 57",
    city: "Berlin",
    region: "NULL",
    postalCode: 12209,
    country: "Germany",
    phone: "030-0074321",
    fax: "030-0076545",
  },
  {
    customerID: "ANATR",
    companyName: "Ana Trujillo Emparedados y helados",
    contactName: "Ana Trujillo",
    contactTitle: "Owner",
    address: "Avda. de la Constitución 2222",
    city: "México D.F.",
    region: "NULL",
    postalCode: "05021",
    country: "Mexico",
    phone: "(5) 555-4729",
    fax: "(5) 555-3745",
  },
  {
    customerID: "ANTON",
    companyName: "Antonio Moreno Taquería",
    contactName: "Antonio Moreno",
    contactTitle: "Owner",
    address: "Mataderos  2312",
    city: "México D.F.",
    region: "NULL",
    postalCode: "05023",
    country: "Mexico",
    phone: "(5) 555-3932",
    fax: "NULL",
  },
  {
    customerID: "AROUT",
    companyName: "Around the Horn",
    contactName: "Thomas Hardy",
    contactTitle: "Sales Representative",
    address: "120 Hanover Sq.",
    city: "London",
    region: "NULL",
    postalCode: "WA1 1DP",
    country: "UK",
    phone: "(171) 555-7788",
    fax: "(171) 555-6750",
  },
  {
    customerID: "BERGS",
    companyName: "Berglunds snabbköp",
    contactName: "Christina Berglund",
    contactTitle: "Order Administrator",
    address: "Berguvsvägen  8",
    city: "Luleå",
    region: "NULL",
    postalCode: "S-958 22",
    country: "Sweden",
    phone: "0921-12 34 65",
    fax: "0921-12 34 67",
  },
  {
    customerID: "BLAUS",
    companyName: "Blauer See Delikatessen",
    contactName: "Hanna Moos",
    contactTitle: "Sales Representative",
    address: "Forsterstr. 57",
    city: "Mannheim",
    region: "NULL",
    postalCode: 68306,
    country: "Germany",
    phone: "0621-08460",
    fax: "0621-08924",
  },
  {
    customerID: "BLONP",
    companyName: "Blondesddsl père et fils",
    contactName: "Frédérique Citeaux",
    contactTitle: "Marketing Manager",
    address: "24 place Kléber",
    city: "Strasbourg",
    region: "NULL",
    postalCode: 67000,
    country: "France",
    phone: "88.60.15.31",
    fax: "88.60.15.32",
  },
  {
    customerID: "BOLID",
    companyName: "Bólido Comidas preparadas",
    contactName: "Martín Sommer",
    contactTitle: "Owner",
    address: "67C Araquil",
    city: "Madrid",
    region: "NULL",
    postalCode: 28023,
    country: "Spain",
    phone: "(91) 555 22 82",
    fax: "(91) 555 91 99",
  },
  {
    customerID: "BONAP",
    companyName: "Bon app'",
    contactName: "Laurence Lebihan",
    contactTitle: "Owner",
    address: "12 rue des Bouchers",
    city: "Marseille",
    region: "NULL",
    postalCode: 13008,
    country: "France",
    phone: "91.24.45.40",
    fax: "91.24.45.41",
  },
  {
    customerID: "BOTTM",
    companyName: "Bottom-Dollar Markets",
    contactName: "Elizabeth Lincoln",
    contactTitle: "Accounting Manager",
    address: "23 Tsawassen Blvd.",
    city: "Tsawassen",
    region: "BC",
    postalCode: "T2F 8M4",
    country: "Canada",
    phone: "(604) 555-4729",
    fax: "(604) 555-3745",
  },
  {
    customerID: "BSBEV",
    companyName: "B's Beverages",
    contactName: "Victoria Ashworth",
    contactTitle: "Sales Representative",
    address: "Fauntleroy Circus",
    city: "London",
    region: "NULL",
    postalCode: "EC2 5NT",
    country: "UK",
    phone: "(171) 555-1212",
    fax: "NULL",
  },
  {
    customerID: "CACTU",
    companyName: "Cactus Comidas para llevar",
    contactName: "Patricio Simpson",
    contactTitle: "Sales Agent",
    address: "Cerrito 333",
    city: "Buenos Aires",
    region: "NULL",
    postalCode: 1010,
    country: "Argentina",
    phone: "(1) 135-5555",
    fax: "(1) 135-4892",
  },
  {
    customerID: "CENTC",
    companyName: "Centro comercial Moctezuma",
    contactName: "Francisco Chang",
    contactTitle: "Marketing Manager",
    address: "Sierras de Granada 9993",
    city: "México D.F.",
    region: "NULL",
    postalCode: "05022",
    country: "Mexico",
    phone: "(5) 555-3392",
    fax: "(5) 555-7293",
  },
  {
    customerID: "CHOPS",
    companyName: "Chop-suey Chinese",
    contactName: "Yang Wang",
    contactTitle: "Owner",
    address: "Hauptstr. 29",
    city: "Bern",
    region: "NULL",
    postalCode: 3012,
    country: "Switzerland",
    phone: "0452-076545",
    fax: "NULL",
  },
  {
    customerID: "COMMI",
    companyName: "Comércio Mineiro",
    contactName: "Pedro Afonso",
    contactTitle: "Sales Associate",
    address: "23 Av. dos Lusíadas",
    city: "Sao Paulo",
    region: "SP",
    postalCode: "05432-043",
    country: "Brazil",
    phone: "(11) 555-7647",
    fax: "NULL",
  },
  {
    customerID: "CONSH",
    companyName: "Consolidated Holdings",
    contactName: "Elizabeth Brown",
    contactTitle: "Sales Representative",
    address: "Berkeley Gardens 12  Brewery",
    city: "London",
    region: "NULL",
    postalCode: "WX1 6LT",
    country: "UK",
    phone: "(171) 555-2282",
    fax: "(171) 555-9199",
  },
  {
    customerID: "DRACD",
    companyName: "Drachenblut Delikatessen",
    contactName: "Sven Ottlieb",
    contactTitle: "Order Administrator",
    address: "Walserweg 21",
    city: "Aachen",
    region: "NULL",
    postalCode: 52066,
    country: "Germany",
    phone: "0241-039123",
    fax: "0241-059428",
  },
  {
    customerID: "DUMON",
    companyName: "Du monde entier",
    contactName: "Janine Labrune",
    contactTitle: "Owner",
    address: "67 rue des Cinquante Otages",
    city: "Nantes",
    region: "NULL",
    postalCode: 44000,
    country: "France",
    phone: "40.67.88.88",
    fax: "40.67.89.89",
  },
  {
    customerID: "EASTC",
    companyName: "Eastern Connection",
    contactName: "Ann Devon",
    contactTitle: "Sales Agent",
    address: "35 King George",
    city: "London",
    region: "NULL",
    postalCode: "WX3 6FW",
    country: "UK",
    phone: "(171) 555-0297",
    fax: "(171) 555-3373",
  },
  {
    customerID: "ERNSH",
    companyName: "Ernst Handel",
    contactName: "Roland Mendel",
    contactTitle: "Sales Manager",
    address: "Kirchgasse 6",
    city: "Graz",
    region: "NULL",
    postalCode: 8010,
    country: "Austria",
    phone: "7675-3425",
    fax: "7675-3426",
  },
  {
    customerID: "FAMIA",
    companyName: "Familia Arquibaldo",
    contactName: "Aria Cruz",
    contactTitle: "Marketing Assistant",
    address: "Rua Orós 92",
    city: "Sao Paulo",
    region: "SP",
    postalCode: "05442-030",
    country: "Brazil",
    phone: "(11) 555-9857",
    fax: "NULL",
  },
  {
    customerID: "FISSA",
    companyName: "FISSA Fabrica Inter. Salchichas S.A.",
    contactName: "Diego Roel",
    contactTitle: "Accounting Manager",
    address: "C/ Moralzarzal 86",
    city: "Madrid",
    region: "NULL",
    postalCode: 28034,
    country: "Spain",
    phone: "(91) 555 94 44",
    fax: "(91) 555 55 93",
  },
  {
    customerID: "FOLIG",
    companyName: "Folies gourmandes",
    contactName: "Martine Rancé",
    contactTitle: "Assistant Sales Agent",
    address: "184 chaussée de Tournai",
    city: "Lille",
    region: "NULL",
    postalCode: 59000,
    country: "France",
    phone: "20.16.10.16",
    fax: "20.16.10.17",
  },
  {
    customerID: "FOLKO",
    companyName: "Folk och fä HB",
    contactName: "Maria Larsson",
    contactTitle: "Owner",
    address: "Åkergatan 24",
    city: "Bräcke",
    region: "NULL",
    postalCode: "S-844 67",
    country: "Sweden",
    phone: "0695-34 67 21",
    fax: "NULL",
  },
  {
    customerID: "FRANK",
    companyName: "Frankenversand",
    contactName: "Peter Franken",
    contactTitle: "Marketing Manager",
    address: "Berliner Platz 43",
    city: "München",
    region: "NULL",
    postalCode: 80805,
    country: "Germany",
    phone: "089-0877310",
    fax: "089-0877451",
  },
  {
    customerID: "FRANR",
    companyName: "France restauration",
    contactName: "Carine Schmitt",
    contactTitle: "Marketing Manager",
    address: "54 rue Royale",
    city: "Nantes",
    region: "NULL",
    postalCode: 44000,
    country: "France",
    phone: "40.32.21.21",
    fax: "40.32.21.20",
  },
  {
    customerID: "FRANS",
    companyName: "Franchi S.p.A.",
    contactName: "Paolo Accorti",
    contactTitle: "Sales Representative",
    address: "Via Monte Bianco 34",
    city: "Torino",
    region: "NULL",
    postalCode: 10100,
    country: "Italy",
    phone: "011-4988260",
    fax: "011-4988261",
  },
  {
    customerID: "FURIB",
    companyName: "Furia Bacalhau e Frutos do Mar",
    contactName: "Lino Rodriguez",
    contactTitle: "Sales Manager",
    address: "Jardim das rosas n. 32",
    city: "Lisboa",
    region: "NULL",
    postalCode: 1675,
    country: "Portugal",
    phone: "(1) 354-2534",
    fax: "(1) 354-2535",
  },
  {
    customerID: "GALED",
    companyName: "Galería del gastrónomo",
    contactName: "Eduardo Saavedra",
    contactTitle: "Marketing Manager",
    address: "Rambla de Cataluña 23",
    city: "Barcelona",
    region: "NULL",
    postalCode: "08022",
    country: "Spain",
    phone: "(93) 203 4560",
    fax: "(93) 203 4561",
  },
  {
    customerID: "GODOS",
    companyName: "Godos Cocina Típica",
    contactName: "José Pedro Freyre",
    contactTitle: "Sales Manager",
    address: "C/ Romero 33",
    city: "Sevilla",
    region: "NULL",
    postalCode: 41101,
    country: "Spain",
    phone: "(95) 555 82 82",
    fax: "NULL",
  },
  {
    customerID: "GOURL",
    companyName: "Gourmet Lanchonetes",
    contactName: "André Fonseca",
    contactTitle: "Sales Associate",
    address: "Av. Brasil 442",
    city: "Campinas",
    region: "SP",
    postalCode: "04876-786",
    country: "Brazil",
    phone: "(11) 555-9482",
    fax: "NULL",
  },
  {
    customerID: "GREAL",
    companyName: "Great Lakes Food Market",
    contactName: "Howard Snyder",
    contactTitle: "Marketing Manager",
    address: "2732 Baker Blvd.",
    city: "Eugene",
    region: "OR",
    postalCode: 97403,
    country: "USA",
    phone: "(503) 555-7555",
    fax: "NULL",
  },
  {
    customerID: "GROSR",
    companyName: "GROSELLA-Restaurante",
    contactName: "Manuel Pereira",
    contactTitle: "Owner",
    address: "5ª Ave. Los Palos Grandes",
    city: "Caracas",
    region: "DF",
    postalCode: 1081,
    country: "Venezuela",
    phone: "(2) 283-2951",
    fax: "(2) 283-3397",
  },
  {
    customerID: "HANAR",
    companyName: "Hanari Carnes",
    contactName: "Mario Pontes",
    contactTitle: "Accounting Manager",
    address: "Rua do Paço 67",
    city: "Rio de Janeiro",
    region: "RJ",
    postalCode: "05454-876",
    country: "Brazil",
    phone: "(21) 555-0091",
    fax: "(21) 555-8765",
  },
  {
    customerID: "HILAA",
    companyName: "HILARION-Abastos",
    contactName: "Carlos Hernández",
    contactTitle: "Sales Representative",
    address: "Carrera 22 con Ave. Carlos Soublette #8-35",
    city: "San Cristóbal",
    region: "Táchira",
    postalCode: 5022,
    country: "Venezuela",
    phone: "(5) 555-1340",
    fax: "(5) 555-1948",
  },
  {
    customerID: "HUNGC",
    companyName: "Hungry Coyote Import Store",
    contactName: "Yoshi Latimer",
    contactTitle: "Sales Representative",
    address: "City Center Plaza 516 Main St.",
    city: "Elgin",
    region: "OR",
    postalCode: 97827,
    country: "USA",
    phone: "(503) 555-6874",
    fax: "(503) 555-2376",
  },
  {
    customerID: "HUNGO",
    companyName: "Hungry Owl All-Night Grocers",
    contactName: "Patricia McKenna",
    contactTitle: "Sales Associate",
    address: "8 Johnstown Road",
    city: "Cork",
    region: "Co. Cork",
    postalCode: "NULL",
    country: "Ireland",
    phone: "2967 542",
    fax: "2967 3333",
  },
  {
    customerID: "ISLAT",
    companyName: "Island Trading",
    contactName: "Helen Bennett",
    contactTitle: "Marketing Manager",
    address: "Garden House Crowther Way",
    city: "Cowes",
    region: "Isle of Wight",
    postalCode: "PO31 7PJ",
    country: "UK",
    phone: "(198) 555-8888",
    fax: "NULL",
  },
  {
    customerID: "KOENE",
    companyName: "Königlich Essen",
    contactName: "Philip Cramer",
    contactTitle: "Sales Associate",
    address: "Maubelstr. 90",
    city: "Brandenburg",
    region: "NULL",
    postalCode: 14776,
    country: "Germany",
    phone: "0555-09876",
    fax: "NULL",
  },
  {
    customerID: "LACOR",
    companyName: "La corne d'abondance",
    contactName: "Daniel Tonini",
    contactTitle: "Sales Representative",
    address: "67 avenue de l'Europe",
    city: "Versailles",
    region: "NULL",
    postalCode: 78000,
    country: "France",
    phone: "30.59.84.10",
    fax: "30.59.85.11",
  },
  {
    customerID: "LAMAI",
    companyName: "La maison d'Asie",
    contactName: "Annette Roulet",
    contactTitle: "Sales Manager",
    address: "1 rue Alsace-Lorraine",
    city: "Toulouse",
    region: "NULL",
    postalCode: 31000,
    country: "France",
    phone: "61.77.61.10",
    fax: "61.77.61.11",
  },
  {
    customerID: "LAUGB",
    companyName: "Laughing Bacchus Wine Cellars",
    contactName: "Yoshi Tannamuri",
    contactTitle: "Marketing Assistant",
    address: "1900 Oak St.",
    city: "Vancouver",
    region: "BC",
    postalCode: "V3F 2K1",
    country: "Canada",
    phone: "(604) 555-3392",
    fax: "(604) 555-7293",
  },
  {
    customerID: "LAZYK",
    companyName: "Lazy K Kountry Store",
    contactName: "John Steel",
    contactTitle: "Marketing Manager",
    address: "12 Orchestra Terrace",
    city: "Walla Walla",
    region: "WA",
    postalCode: 99362,
    country: "USA",
    phone: "(509) 555-7969",
    fax: "(509) 555-6221",
  },
  {
    customerID: "LEHMS",
    companyName: "Lehmanns Marktstand",
    contactName: "Renate Messner",
    contactTitle: "Sales Representative",
    address: "Magazinweg 7",
    city: "Frankfurt a.M.",
    region: "NULL",
    postalCode: 60528,
    country: "Germany",
    phone: "069-0245984",
    fax: "069-0245874",
  },
  {
    customerID: "LETSS",
    companyName: "Let's Stop N Shop",
    contactName: "Jaime Yorres",
    contactTitle: "Owner",
    address: "87 Polk St. Suite 5",
    city: "San Francisco",
    region: "CA",
    postalCode: 94117,
    country: "USA",
    phone: "(415) 555-5938",
    fax: "NULL",
  },
  {
    customerID: "LILAS",
    companyName: "LILA-Supermercado",
    contactName: "Carlos González",
    contactTitle: "Accounting Manager",
    address: "Carrera 52 con Ave. Bolívar #65-98 Llano Largo",
    city: "Barquisimeto",
    region: "Lara",
    postalCode: 3508,
    country: "Venezuela",
    phone: "(9) 331-6954",
    fax: "(9) 331-7256",
  },
  {
    customerID: "LINOD",
    companyName: "LINO-Delicateses",
    contactName: "Felipe Izquierdo",
    contactTitle: "Owner",
    address: "Ave. 5 de Mayo Porlamar",
    city: "I. de Margarita",
    region: "Nueva Esparta",
    postalCode: 4980,
    country: "Venezuela",
    phone: "(8) 34-56-12",
    fax: "(8) 34-93-93",
  },
  {
    customerID: "LONEP",
    companyName: "Lonesome Pine Restaurant",
    contactName: "Fran Wilson",
    contactTitle: "Sales Manager",
    address: "89 Chiaroscuro Rd.",
    city: "Portland",
    region: "OR",
    postalCode: 97219,
    country: "USA",
    phone: "(503) 555-9573",
    fax: "(503) 555-9646",
  },
  {
    customerID: "MAGAA",
    companyName: "Magazzini Alimentari Riuniti",
    contactName: "Giovanni Rovelli",
    contactTitle: "Marketing Manager",
    address: "Via Ludovico il Moro 22",
    city: "Bergamo",
    region: "NULL",
    postalCode: 24100,
    country: "Italy",
    phone: "035-640230",
    fax: "035-640231",
  },
  {
    customerID: "MAISD",
    companyName: "Maison Dewey",
    contactName: "Catherine Dewey",
    contactTitle: "Sales Agent",
    address: "Rue Joseph-Bens 532",
    city: "Bruxelles",
    region: "NULL",
    postalCode: "B-1180",
    country: "Belgium",
    phone: "(02) 201 24 67",
    fax: "(02) 201 24 68",
  },
  {
    customerID: "MEREP",
    companyName: "Mère Paillarde",
    contactName: "Jean Fresnière",
    contactTitle: "Marketing Assistant",
    address: "43 rue St. Laurent",
    city: "Montréal",
    region: "Québec",
    postalCode: "H1J 1C3",
    country: "Canada",
    phone: "(514) 555-8054",
    fax: "(514) 555-8055",
  },
  {
    customerID: "MORGK",
    companyName: "Morgenstern Gesundkost",
    contactName: "Alexander Feuer",
    contactTitle: "Marketing Assistant",
    address: "Heerstr. 22",
    city: "Leipzig",
    region: "NULL",
    postalCode: "04179",
    country: "Germany",
    phone: "0342-023176",
    fax: "NULL",
  },
  {
    customerID: "NORTS",
    companyName: "North/South",
    contactName: "Simon Crowther",
    contactTitle: "Sales Associate",
    address: "South House 300 Queensbridge",
    city: "London",
    region: "NULL",
    postalCode: "SW7 1RZ",
    country: "UK",
    phone: "(171) 555-7733",
    fax: "(171) 555-2530",
  },
  {
    customerID: "OCEAN",
    companyName: "Océano Atlántico Ltda.",
    contactName: "Yvonne Moncada",
    contactTitle: "Sales Agent",
    address: "Ing. Gustavo Moncada 8585 Piso 20-A",
    city: "Buenos Aires",
    region: "NULL",
    postalCode: 1010,
    country: "Argentina",
    phone: "(1) 135-5333",
    fax: "(1) 135-5535",
  },
  {
    customerID: "OLDWO",
    companyName: "Old World Delicatessen",
    contactName: "Rene Phillips",
    contactTitle: "Sales Representative",
    address: "2743 Bering St.",
    city: "Anchorage",
    region: "AK",
    postalCode: 99508,
    country: "USA",
    phone: "(907) 555-7584",
    fax: "(907) 555-2880",
  },
  {
    customerID: "OTTIK",
    companyName: "Ottilies Käseladen",
    contactName: "Henriette Pfalzheim",
    contactTitle: "Owner",
    address: "Mehrheimerstr. 369",
    city: "Köln",
    region: "NULL",
    postalCode: 50739,
    country: "Germany",
    phone: "0221-0644327",
    fax: "0221-0765721",
  },
  {
    customerID: "PARIS",
    companyName: "Paris spécialités",
    contactName: "Marie Bertrand",
    contactTitle: "Owner",
    address: "265 boulevard Charonne",
    city: "Paris",
    region: "NULL",
    postalCode: 75012,
    country: "France",
    phone: "(1) 42.34.22.66",
    fax: "(1) 42.34.22.77",
  },
  {
    customerID: "PERIC",
    companyName: "Pericles Comidas clásicas",
    contactName: "Guillermo Fernández",
    contactTitle: "Sales Representative",
    address: "Calle Dr. Jorge Cash 321",
    city: "México D.F.",
    region: "NULL",
    postalCode: "05033",
    country: "Mexico",
    phone: "(5) 552-3745",
    fax: "(5) 545-3745",
  },
  {
    customerID: "PICCO",
    companyName: "Piccolo und mehr",
    contactName: "Georg Pipps",
    contactTitle: "Sales Manager",
    address: "Geislweg 14",
    city: "Salzburg",
    region: "NULL",
    postalCode: 5020,
    country: "Austria",
    phone: "6562-9722",
    fax: "6562-9723",
  },
  {
    customerID: "PRINI",
    companyName: "Princesa Isabel Vinhos",
    contactName: "Isabel de Castro",
    contactTitle: "Sales Representative",
    address: "Estrada da saúde n. 58",
    city: "Lisboa",
    region: "NULL",
    postalCode: 1756,
    country: "Portugal",
    phone: "(1) 356-5634",
    fax: "NULL",
  },
  {
    customerID: "QUEDE",
    companyName: "Que Delícia",
    contactName: "Bernardo Batista",
    contactTitle: "Accounting Manager",
    address: "Rua da Panificadora",
    city: "12Rio de Janeiro",
    region: "RJ",
    postalCode: "02389-673",
    country: "Brazil",
    phone: "(21) 555-4252",
    fax: "(21) 555-4545",
  },
  {
    customerID: "QUEEN",
    companyName: "Queen Cozinha",
    contactName: "Lúcia Carvalho",
    contactTitle: "Marketing Assistant",
    address: "Alameda dos Canàrios 891",
    city: "Sao Paulo",
    region: "SP",
    postalCode: "05487-020",
    country: "Brazil",
    phone: "(11) 555-1189",
    fax: "NULL",
  },
  {
    customerID: "QUICK",
    companyName: "QUICK-Stop",
    contactName: "Horst Kloss",
    contactTitle: "Accounting Manager",
    address: "Taucherstraße 10",
    city: "Cunewalde",
    region: "NULL",
    postalCode: "01307",
    country: "Germany",
    phone: "0372-035188",
    fax: "NULL",
  },
  {
    customerID: "RANCH",
    companyName: "Rancho grande",
    contactName: "Sergio Gutiérrez",
    contactTitle: "Sales Representative",
    address: "Av. del Libertador 900",
    city: "Buenos Aires",
    region: "NULL",
    postalCode: 1010,
    country: "Argentina",
    phone: "(1) 123-5555",
    fax: "(1) 123-5556",
  },
  {
    customerID: "RATTC",
    companyName: "Rattlesnake Canyon Grocery",
    contactName: "Paula Wilson",
    contactTitle: "Assistant Sales Representative",
    address: "2817 Milton Dr.",
    city: "Albuquerque",
    region: "NM",
    postalCode: 87110,
    country: "USA",
    phone: "(505) 555-5939",
    fax: "(505) 555-3620",
  },
  {
    customerID: "REGGC",
    companyName: "Reggiani Caseifici",
    contactName: "Maurizio Moroni",
    contactTitle: "Sales Associate",
    address: "Strada Provinciale 124",
    city: "Reggio Emilia",
    region: "NULL",
    postalCode: 42100,
    country: "Italy",
    phone: "0522-556721",
    fax: "0522-556722",
  },
  {
    customerID: "RICAR",
    companyName: "Ricardo Adocicados",
    contactName: "Janete Limeira",
    contactTitle: "Assistant Sales Agent",
    address: "Av. Copacabana 267",
    city: "Rio de Janeiro",
    region: "RJ",
    postalCode: "02389-890",
    country: "Brazil",
    phone: "(21) 555-3412",
    fax: "NULL",
  },
  {
    customerID: "RICSU",
    companyName: "Richter Supermarkt",
    contactName: "Michael Holz",
    contactTitle: "Sales Manager",
    address: "Grenzacherweg 237",
    city: "Genève",
    region: "NULL",
    postalCode: 1203,
    country: "Switzerland",
    phone: "0897-034214",
    fax: "NULL",
  },
  {
    customerID: "ROMEY",
    companyName: "Romero y tomillo",
    contactName: "Alejandra Camino",
    contactTitle: "Accounting Manager",
    address: "Gran Vía 1",
    city: "Madrid",
    region: "NULL",
    postalCode: 28001,
    country: "Spain",
    phone: "(91) 745 6200",
    fax: "(91) 745 6210",
  },
  {
    customerID: "SANTG",
    companyName: "Santé Gourmet",
    contactName: "Jonas Bergulfsen",
    contactTitle: "Owner",
    address: "Erling Skakkes gate 78",
    city: "Stavern",
    region: "NULL",
    postalCode: 4110,
    country: "Norway",
    phone: "07-98 92 35",
    fax: "07-98 92 47",
  },
  {
    customerID: "SAVEA",
    companyName: "Save-a-lot Markets",
    contactName: "Jose Pavarotti",
    contactTitle: "Sales Representative",
    address: "187 Suffolk Ln.",
    city: "Boise",
    region: "ID",
    postalCode: 83720,
    country: "USA",
    phone: "(208) 555-8097",
    fax: "NULL",
  },
  {
    customerID: "SEVES",
    companyName: "Seven Seas Imports",
    contactName: "Hari Kumar",
    contactTitle: "Sales Manager",
    address: "90 Wadhurst Rd.",
    city: "London",
    region: "NULL",
    postalCode: "OX15 4NB",
    country: "UK",
    phone: "(171) 555-1717",
    fax: "(171) 555-5646",
  },
  {
    customerID: "SIMOB",
    companyName: "Simons bistro",
    contactName: "Jytte Petersen",
    contactTitle: "Owner",
    address: "Vinbæltet 34",
    city: "Kobenhavn",
    region: "NULL",
    postalCode: 1734,
    country: "Denmark",
    phone: "31 12 34 56",
    fax: "31 13 35 57",
  },
  {
    customerID: "SPECD",
    companyName: "Spécialités du monde",
    contactName: "Dominique Perrier",
    contactTitle: "Marketing Manager",
    address: "25 rue Lauriston",
    city: "Paris",
    region: "NULL",
    postalCode: 75016,
    country: "France",
    phone: "(1) 47.55.60.10",
    fax: "(1) 47.55.60.20",
  },
  {
    customerID: "SPLIR",
    companyName: "Split Rail Beer & Ale",
    contactName: "Art Braunschweiger",
    contactTitle: "Sales Manager",
    address: "P.O. Box 555",
    city: "Lander",
    region: "WY",
    postalCode: 82520,
    country: "USA",
    phone: "(307) 555-4680",
    fax: "(307) 555-6525",
  },
  {
    customerID: "SUPRD",
    companyName: "Suprêmes délices",
    contactName: "Pascale Cartrain",
    contactTitle: "Accounting Manager",
    address: "Boulevard Tirou 255",
    city: "Charleroi",
    region: "NULL",
    postalCode: "B-6000",
    country: "Belgium",
    phone: "(071) 23 67 22 20",
    fax: "(071) 23 67 22 21",
  },
  {
    customerID: "THEBI",
    companyName: "The Big Cheese",
    contactName: "Liz Nixon",
    contactTitle: "Marketing Manager",
    address: "89 Jefferson Way Suite 2",
    city: "Portland",
    region: "OR",
    postalCode: 97201,
    country: "USA",
    phone: "(503) 555-3612",
    fax: "NULL",
  },
  {
    customerID: "THECR",
    companyName: "The Cracker Box",
    contactName: "Liu Wong",
    contactTitle: "Marketing Assistant",
    address: "55 Grizzly Peak Rd.",
    city: "Butte",
    region: "MT",
    postalCode: 59801,
    country: "USA",
    phone: "(406) 555-5834",
    fax: "(406) 555-8083",
  },
  {
    customerID: "TOMSP",
    companyName: "Toms Spezialitäten",
    contactName: "Karin Josephs",
    contactTitle: "Marketing Manager",
    address: "Luisenstr. 48",
    city: "Münster",
    region: "NULL",
    postalCode: 44087,
    country: "Germany",
    phone: "0251-031259",
    fax: "0251-035695",
  },
  {
    customerID: "TORTU",
    companyName: "Tortuga Restaurante",
    contactName: "Miguel Angel Paolino",
    contactTitle: "Owner",
    address: "Avda. Azteca 123",
    city: "México D.F.",
    region: "NULL",
    postalCode: "05033",
    country: "Mexico",
    phone: "(5) 555-2933",
    fax: "NULL",
  },
  {
    customerID: "TRADH",
    companyName: "Tradição Hipermercados",
    contactName: "Anabela Domingues",
    contactTitle: "Sales Representative",
    address: "Av. Inês de Castro 414",
    city: "Sao Paulo",
    region: "SP",
    postalCode: "05634-030",
    country: "Brazil",
    phone: "(11) 555-2167",
    fax: "(11) 555-2168",
  },
  {
    customerID: "TRAIH",
    companyName: "Trail's Head Gourmet Provisioners",
    contactName: "Helvetius Nagy",
    contactTitle: "Sales Associate",
    address: "722 DaVinci Blvd.",
    city: "Kirkland",
    region: "WA",
    postalCode: 98034,
    country: "USA",
    phone: "(206) 555-8257",
    fax: "(206) 555-2174",
  },
  {
    customerID: "VAFFE",
    companyName: "Vaffeljernet",
    contactName: "Palle Ibsen",
    contactTitle: "Sales Manager",
    address: "Smagsloget 45",
    city: "Århus",
    region: "NULL",
    postalCode: 8200,
    country: "Denmark",
    phone: "86 21 32 43",
    fax: "86 22 33 44",
  },
  {
    customerID: "VICTE",
    companyName: "Victuailles en stock",
    contactName: "Mary Saveley",
    contactTitle: "Sales Agent",
    address: "2 rue du Commerce",
    city: "Lyon",
    region: "NULL",
    postalCode: 69004,
    country: "France",
    phone: "78.32.54.86",
    fax: "78.32.54.87",
  },
  {
    customerID: "VINET",
    companyName: "Vins et alcools Chevalier",
    contactName: "Paul Henriot",
    contactTitle: "Accounting Manager",
    address: "59 rue de l'Abbaye",
    city: "Reims",
    region: "NULL",
    postalCode: 51100,
    country: "France",
    phone: "26.47.15.10",
    fax: "26.47.15.11",
  },
  {
    customerID: "WANDK",
    companyName: "Die Wandernde Kuh",
    contactName: "Rita Müller",
    contactTitle: "Sales Representative",
    address: "Adenauerallee 900",
    city: "Stuttgart",
    region: "NULL",
    postalCode: 70563,
    country: "Germany",
    phone: "0711-020361",
    fax: "0711-035428",
  },
  {
    customerID: "WARTH",
    companyName: "Wartian Herkku",
    contactName: "Pirkko Koskitalo",
    contactTitle: "Accounting Manager",
    address: "Torikatu 38",
    city: "Oulu",
    region: "NULL",
    postalCode: 90110,
    country: "Finland",
    phone: "981-443655",
    fax: "981-443655",
  },
  {
    customerID: "WELLI",
    companyName: "Wellington Importadora",
    contactName: "Paula Parente",
    contactTitle: "Sales Manager",
    address: "Rua do Mercado 12",
    city: "Resende",
    region: "SP",
    postalCode: "08737-363",
    country: "Brazil",
    phone: "(14) 555-8122",
    fax: "NULL",
  },
  {
    customerID: "WHITC",
    companyName: "White Clover Markets",
    contactName: "Karl Jablonski",
    contactTitle: "Owner",
    address: "305 - 14th Ave. S. Suite 3B",
    city: "Seattle",
    region: "WA",
    postalCode: 98128,
    country: "USA",
    phone: "(206) 555-4112",
    fax: "(206) 555-4115",
  },
  {
    customerID: "WILMK",
    companyName: "Wilman Kala",
    contactName: "Matti Karttunen",
    contactTitle: "Owner/Marketing Assistant",
    address: "Keskuskatu 45",
    city: "Helsinki",
    region: "NULL",
    postalCode: 21240,
    country: "Finland",
    phone: "90-224 8858",
    fax: "90-224 8858",
  },
  {
    customerID: "WOLZA",
    companyName: "Wolski  Zajazd",
    contactName: "Zbyszek Piestrzeniewicz",
    contactTitle: "Owner",
    address: "ul. Filtrowa 68",
    city: "Warszawa",
    region: "NULL",
    postalCode: "01-012",
    country: "Poland",
    phone: "(26) 642-7012",
    fax: "(26) 642-7012",
  },
];
const employees = [
  {
    employeeID: 1,
    lastName: "Davolio",
    firstName: "Nancy",
    title: "Sales Representative",
    titleOfCourtesy: "Ms.",
    birthDate: "1948-12-08 00:00:00.000",
    hireDate: "1992-05-01 00:00:00.000",
    address: "507 20th Ave. E. Apt. 2A",
    city: "Seattle",
    region: "WA",
    postalCode: 98122,
    country: "USA",
    homePhone: "(206) 555-9857",
    extension: 5467,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D20540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Education includes a BA in psychology from Colorado State University in 1970.  She also completed The Art of the Cold Call.  Nancy is a member of Toastmasters International.",
    reportsTo: 2,
    photoPath: "http://accweb/emmployees/davolio.bmp",
  },
  {
    employeeID: 2,
    lastName: "Fuller",
    firstName: "Andrew",
    title: "Vice President Sales",
    titleOfCourtesy: "Dr.",
    birthDate: "1952-02-19 00:00:00.000",
    hireDate: "1992-08-14 00:00:00.000",
    address: "908 W. Capital Way",
    city: "Tacoma",
    region: "WA",
    postalCode: 98401,
    country: "USA",
    homePhone: "(206) 555-9482",
    extension: 3457,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D20540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Andrew received his BTS commercial in 1974 and a Ph.D. in international marketing from the University of Dallas in 1981.  He is fluent in French and Italian and reads German.  He joined the company as a sales representative was promoted to sales manager",
    reportsTo: "NULL",
    photoPath: "http://accweb/emmployees/fuller.bmp",
  },
  {
    employeeID: 3,
    lastName: "Leverling",
    firstName: "Janet",
    title: "Sales Representative",
    titleOfCourtesy: "Ms.",
    birthDate: "1963-08-30 00:00:00.000",
    hireDate: "1992-04-01 00:00:00.000",
    address: "722 Moss Bay Blvd.",
    city: "Kirkland",
    region: "WA",
    postalCode: 98033,
    country: "USA",
    homePhone: "(206) 555-3412",
    extension: 3355,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000080540000424D80540000000000007600000028000000C0000000E0000000010004000000000000540000CE0E0000D80E0000000000",
    notes:
      "Janet has a BS degree in chemistry from Boston College (1984). She has also completed a certificate program in food retailing management.  Janet was hired as a sales associate in 1991 and promoted to sales representative in February 1992.",
    reportsTo: 2,
    photoPath: "http://accweb/emmployees/leverling.bmp",
  },
  {
    employeeID: 4,
    lastName: "Peacock",
    firstName: "Margaret",
    title: "Sales Representative",
    titleOfCourtesy: "Mrs.",
    birthDate: "1937-09-19 00:00:00.000",
    hireDate: "1993-05-03 00:00:00.000",
    address: "4110 Old Redmond Rd.",
    city: "Redmond",
    region: "WA",
    postalCode: 98052,
    country: "USA",
    homePhone: "(206) 555-8122",
    extension: 5176,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D20540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Margaret holds a BA in English literature from Concordia College (1958) and an MA from the American Institute of Culinary Arts (1966).  She was assigned to the London office temporarily from July through November 1992.",
    reportsTo: 2,
    photoPath: "http://accweb/emmployees/peacock.bmp",
  },
  {
    employeeID: 5,
    lastName: "Buchanan",
    firstName: "Steven",
    title: "Sales Manager",
    titleOfCourtesy: "Mr.",
    birthDate: "1955-03-04 00:00:00.000",
    hireDate: "1993-10-17 00:00:00.000",
    address: "14 Garrett Hill",
    city: "London",
    region: "NULL",
    postalCode: "SW1 8JR",
    country: "UK",
    homePhone: "(71) 555-4848",
    extension: 3453,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D20540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Steven Buchanan graduated from St. Andrews University in Scotland with a BSC degree in 1976.  Upon joining the company as a sales representative in 1992 he spent 6 months in an orientation program at the Seattle office.",
    reportsTo: 2,
    photoPath: "http://accweb/emmployees/buchanan.bmp",
  },
  {
    employeeID: 6,
    lastName: "Suyama",
    firstName: "Michael",
    title: "Sales Representative",
    titleOfCourtesy: "Mr.",
    birthDate: "1963-07-02 00:00:00.000",
    hireDate: "1993-10-17 00:00:00.000",
    address: "Coventry House Miner Rd.",
    city: "London",
    region: "NULL",
    postalCode: "EC2 7JR",
    country: "UK",
    homePhone: "(71) 555-7773",
    extension: 428,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D16540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Michael is a graduate of Sussex University (MA Economics 1983) and the University of California at Los Angeles (MBA marketing 1986).  He has also taken the courses Multi-Cultural Selling and Time Management for the Sales Professional.",
    reportsTo: 5,
    photoPath: "http://accweb/emmployees/davolio.bmp",
  },
  {
    employeeID: 7,
    lastName: "King",
    firstName: "Robert",
    title: "Sales Representative",
    titleOfCourtesy: "Mr.",
    birthDate: "1960-05-29 00:00:00.000",
    hireDate: "1994-01-02 00:00:00.000",
    address: "Edgeham Hollow Winchester Way",
    city: "London",
    region: "NULL",
    postalCode: "RG1 9SP",
    country: "UK",
    homePhone: "(71) 555-5598",
    extension: 465,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D16540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Robert King served in the Peace Corps and traveled extensively before completing his degree in English at the University of Michigan in 1992 the year he joined the company.",
    reportsTo: 5,
    photoPath: "http://accweb/emmployees/davolio.bmp",
  },
  {
    employeeID: 8,
    lastName: "Callahan",
    firstName: "Laura",
    title: "Inside Sales Coordinator",
    titleOfCourtesy: "Ms.",
    birthDate: "1958-01-09 00:00:00.000",
    hireDate: "1994-03-05 00:00:00.000",
    address: "4726 11th Ave. N.E.",
    city: "Seattle",
    region: "WA",
    postalCode: 98105,
    country: "USA",
    homePhone: "(206) 555-1189",
    extension: 2344,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D16540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Laura received a BA in psychology from the University of Washington.  She has also completed a course in business French.  She reads and writes French.",
    reportsTo: 2,
    photoPath: "http://accweb/emmployees/davolio.bmp",
  },
  {
    employeeID: 9,
    lastName: "Dodsworth",
    firstName: "Anne",
    title: "Sales Representative",
    titleOfCourtesy: "Ms.",
    birthDate: "1966-01-27 00:00:00.000",
    hireDate: "1994-11-15 00:00:00.000",
    address: "7 Houndstooth Rd.",
    city: "London",
    region: "NULL",
    postalCode: "WG2 7LT",
    country: "UK",
    homePhone: "(71) 555-4444",
    extension: 452,
    photo:
      "0x151C2F00020000000D000E0014002100FFFFFFFF4269746D617020496D616765005061696E742E506963747572650001050000020000000700000050427275736800000000000000000020540000424D16540000000000007600000028000000C0000000DF0000000100040000000000A0530000CE0E0000D80E0000000000",
    notes:
      "Anne has a BA degree in English from St. Lawrence College.  She is fluent in French and German.",
    reportsTo: 5,
    photoPath: "http://accweb/emmployees/davolio.bmp",
  },
];
const order_details = [
  {
    orderID: 10389,
    productID: 55,
    unitPrice: 19.2,
    quantity: 15,
    discount: 0,
  },
  {
    orderID: 10389,
    productID: 62,
    unitPrice: 39.4,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10389,
    productID: 70,
    unitPrice: 12,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10390,
    productID: 31,
    unitPrice: 10,
    quantity: 60,
    discount: 0.1,
  },
  {
    orderID: 10390,
    productID: 35,
    unitPrice: 14.4,
    quantity: 40,
    discount: 0.1,
  },
  {
    orderID: 10390,
    productID: 46,
    unitPrice: 9.6,
    quantity: 45,
    discount: 0,
  },
  {
    orderID: 10390,
    productID: 72,
    unitPrice: 27.8,
    quantity: 24,
    discount: 0.1,
  },
  {
    orderID: 10391,
    productID: 13,
    unitPrice: 4.8,
    quantity: 18,
    discount: 0,
  },
  {
    orderID: 10392,
    productID: 69,
    unitPrice: 28.8,
    quantity: 50,
    discount: 0,
  },
  {
    orderID: 10393,
    productID: 2,
    unitPrice: 15.2,
    quantity: 25,
    discount: 0.25,
  },
  {
    orderID: 10393,
    productID: 14,
    unitPrice: 18.6,
    quantity: 42,
    discount: 0.25,
  },
  {
    orderID: 10393,
    productID: 25,
    unitPrice: 11.2,
    quantity: 7,
    discount: 0.25,
  },
  {
    orderID: 10393,
    productID: 26,
    unitPrice: 24.9,
    quantity: 70,
    discount: 0.25,
  },
  {
    orderID: 10393,
    productID: 31,
    unitPrice: 10,
    quantity: 32,
    discount: 0,
  },
  {
    orderID: 10394,
    productID: 13,
    unitPrice: 4.8,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10394,
    productID: 62,
    unitPrice: 39.4,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10395,
    productID: 46,
    unitPrice: 9.6,
    quantity: 28,
    discount: 0.1,
  },
  {
    orderID: 10395,
    productID: 53,
    unitPrice: 26.2,
    quantity: 70,
    discount: 0.1,
  },
  {
    orderID: 10395,
    productID: 69,
    unitPrice: 28.8,
    quantity: 8,
    discount: 0,
  },
  {
    orderID: 10396,
    productID: 23,
    unitPrice: 7.2,
    quantity: 40,
    discount: 0,
  },
  {
    orderID: 10396,
    productID: 71,
    unitPrice: 17.2,
    quantity: 60,
    discount: 0,
  },
  {
    orderID: 10396,
    productID: 72,
    unitPrice: 27.8,
    quantity: 21,
    discount: 0,
  },
  {
    orderID: 10397,
    productID: 21,
    unitPrice: 8,
    quantity: 10,
    discount: 0.15,
  },
  {
    orderID: 10397,
    productID: 51,
    unitPrice: 42.4,
    quantity: 18,
    discount: 0.15,
  },
  {
    orderID: 10398,
    productID: 35,
    unitPrice: 14.4,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10398,
    productID: 55,
    unitPrice: 19.2,
    quantity: 120,
    discount: 0.1,
  },
  {
    orderID: 10399,
    productID: 68,
    unitPrice: 10,
    quantity: 60,
    discount: 0,
  },
  {
    orderID: 10399,
    productID: 71,
    unitPrice: 17.2,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10399,
    productID: 76,
    unitPrice: 14.4,
    quantity: 35,
    discount: 0,
  },
  {
    orderID: 10399,
    productID: 77,
    unitPrice: 10.4,
    quantity: 14,
    discount: 0,
  },
  {
    orderID: 10400,
    productID: 29,
    unitPrice: 99,
    quantity: 21,
    discount: 0,
  },
  {
    orderID: 10400,
    productID: 35,
    unitPrice: 14.4,
    quantity: 35,
    discount: 0,
  },
  {
    orderID: 10400,
    productID: 49,
    unitPrice: 16,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10401,
    productID: 30,
    unitPrice: 20.7,
    quantity: 18,
    discount: 0,
  },
  {
    orderID: 10401,
    productID: 56,
    unitPrice: 30.4,
    quantity: 70,
    discount: 0,
  },
  {
    orderID: 10401,
    productID: 65,
    unitPrice: 16.8,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10401,
    productID: 71,
    unitPrice: 17.2,
    quantity: 60,
    discount: 0,
  },
  {
    orderID: 10402,
    productID: 23,
    unitPrice: 7.2,
    quantity: 60,
    discount: 0,
  },
  {
    orderID: 10402,
    productID: 63,
    unitPrice: 35.1,
    quantity: 65,
    discount: 0,
  },
  {
    orderID: 10403,
    productID: 16,
    unitPrice: 13.9,
    quantity: 21,
    discount: 0.15,
  },
  {
    orderID: 10403,
    productID: 48,
    unitPrice: 10.2,
    quantity: 70,
    discount: 0.15,
  },
  {
    orderID: 10404,
    productID: 26,
    unitPrice: 24.9,
    quantity: 30,
    discount: 0.05,
  },
  {
    orderID: 10404,
    productID: 42,
    unitPrice: 11.2,
    quantity: 40,
    discount: 0.05,
  },
  {
    orderID: 10404,
    productID: 49,
    unitPrice: 16,
    quantity: 30,
    discount: 0.05,
  },
  {
    orderID: 10405,
    productID: 3,
    unitPrice: 8,
    quantity: 50,
    discount: 0,
  },
  {
    orderID: 10406,
    productID: 1,
    unitPrice: 14.4,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10406,
    productID: 21,
    unitPrice: 8,
    quantity: 30,
    discount: 0.1,
  },
  {
    orderID: 10406,
    productID: 28,
    unitPrice: 36.4,
    quantity: 42,
    discount: 0.1,
  },
  {
    orderID: 10406,
    productID: 36,
    unitPrice: 15.2,
    quantity: 5,
    discount: 0.1,
  },
  {
    orderID: 10406,
    productID: 40,
    unitPrice: 14.7,
    quantity: 2,
    discount: 0.1,
  },
  {
    orderID: 10407,
    productID: 11,
    unitPrice: 16.8,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10407,
    productID: 69,
    unitPrice: 28.8,
    quantity: 15,
    discount: 0,
  },
  {
    orderID: 10407,
    productID: 71,
    unitPrice: 17.2,
    quantity: 15,
    discount: 0,
  },
  {
    orderID: 10408,
    productID: 37,
    unitPrice: 20.8,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10408,
    productID: 54,
    unitPrice: 5.9,
    quantity: 6,
    discount: 0,
  },
  {
    orderID: 10408,
    productID: 62,
    unitPrice: 39.4,
    quantity: 35,
    discount: 0,
  },
  {
    orderID: 10409,
    productID: 14,
    unitPrice: 18.6,
    quantity: 12,
    discount: 0,
  },
  {
    orderID: 10409,
    productID: 21,
    unitPrice: 8,
    quantity: 12,
    discount: 0,
  },
  {
    orderID: 10410,
    productID: 33,
    unitPrice: 2,
    quantity: 49,
    discount: 0,
  },
  {
    orderID: 10410,
    productID: 59,
    unitPrice: 44,
    quantity: 16,
    discount: 0,
  },
  {
    orderID: 10411,
    productID: 41,
    unitPrice: 7.7,
    quantity: 25,
    discount: 0.2,
  },
  {
    orderID: 10411,
    productID: 44,
    unitPrice: 15.5,
    quantity: 40,
    discount: 0.2,
  },
  {
    orderID: 10411,
    productID: 59,
    unitPrice: 44,
    quantity: 9,
    discount: 0.2,
  },
  {
    orderID: 10412,
    productID: 14,
    unitPrice: 18.6,
    quantity: 20,
    discount: 0.1,
  },
  {
    orderID: 10413,
    productID: 1,
    unitPrice: 14.4,
    quantity: 24,
    discount: 0,
  },
  {
    orderID: 10413,
    productID: 62,
    unitPrice: 39.4,
    quantity: 40,
    discount: 0,
  },
  {
    orderID: 10413,
    productID: 76,
    unitPrice: 14.4,
    quantity: 14,
    discount: 0,
  },
  {
    orderID: 10414,
    productID: 19,
    unitPrice: 7.3,
    quantity: 18,
    discount: 0.05,
  },
  {
    orderID: 10414,
    productID: 33,
    unitPrice: 2,
    quantity: 50,
    discount: 0,
  },
  {
    orderID: 10415,
    productID: 17,
    unitPrice: 31.2,
    quantity: 2,
    discount: 0,
  },
  {
    orderID: 10415,
    productID: 33,
    unitPrice: 2,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10416,
    productID: 19,
    unitPrice: 7.3,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10416,
    productID: 53,
    unitPrice: 26.2,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10416,
    productID: 57,
    unitPrice: 15.6,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10417,
    productID: 38,
    unitPrice: 210.8,
    quantity: 50,
    discount: 0,
  },
  {
    orderID: 10417,
    productID: 46,
    unitPrice: 9.6,
    quantity: 2,
    discount: 0.25,
  },
  {
    orderID: 10417,
    productID: 68,
    unitPrice: 10,
    quantity: 36,
    discount: 0.25,
  },
  {
    orderID: 10417,
    productID: 77,
    unitPrice: 10.4,
    quantity: 35,
    discount: 0,
  },
  {
    orderID: 10418,
    productID: 2,
    unitPrice: 15.2,
    quantity: 60,
    discount: 0,
  },
  {
    orderID: 10418,
    productID: 47,
    unitPrice: 7.6,
    quantity: 55,
    discount: 0,
  },
  {
    orderID: 10418,
    productID: 61,
    unitPrice: 22.8,
    quantity: 16,
    discount: 0,
  },
  {
    orderID: 10418,
    productID: 74,
    unitPrice: 8,
    quantity: 15,
    discount: 0,
  },
  {
    orderID: 10419,
    productID: 60,
    unitPrice: 27.2,
    quantity: 60,
    discount: 0.05,
  },
  {
    orderID: 10419,
    productID: 69,
    unitPrice: 28.8,
    quantity: 20,
    discount: 0.05,
  },
  {
    orderID: 10420,
    productID: 9,
    unitPrice: 77.6,
    quantity: 20,
    discount: 0.1,
  },
  {
    orderID: 10420,
    productID: 13,
    unitPrice: 4.8,
    quantity: 2,
    discount: 0.1,
  },
  {
    orderID: 10420,
    productID: 70,
    unitPrice: 12,
    quantity: 8,
    discount: 0.1,
  },
  {
    orderID: 10420,
    productID: 73,
    unitPrice: 12,
    quantity: 20,
    discount: 0.1,
  },
  {
    orderID: 10421,
    productID: 19,
    unitPrice: 7.3,
    quantity: 4,
    discount: 0.15,
  },
  {
    orderID: 10421,
    productID: 26,
    unitPrice: 24.9,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10421,
    productID: 53,
    unitPrice: 26.2,
    quantity: 15,
    discount: 0.15,
  },
  {
    orderID: 10421,
    productID: 77,
    unitPrice: 10.4,
    quantity: 10,
    discount: 0.15,
  },
  {
    orderID: 10422,
    productID: 26,
    unitPrice: 24.9,
    quantity: 2,
    discount: 0,
  },
  {
    orderID: 10423,
    productID: 31,
    unitPrice: 10,
    quantity: 14,
    discount: 0,
  },
  {
    orderID: 10423,
    productID: 59,
    unitPrice: 44,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10424,
    productID: 35,
    unitPrice: 14.4,
    quantity: 60,
    discount: 0.2,
  },
  {
    orderID: 10424,
    productID: 38,
    unitPrice: 210.8,
    quantity: 49,
    discount: 0.2,
  },
  {
    orderID: 10424,
    productID: 68,
    unitPrice: 10,
    quantity: 30,
    discount: 0.2,
  },
  {
    orderID: 10425,
    productID: 55,
    unitPrice: 19.2,
    quantity: 10,
    discount: 0.25,
  },
  {
    orderID: 10425,
    productID: 76,
    unitPrice: 14.4,
    quantity: 20,
    discount: 0.25,
  },
  {
    orderID: 10426,
    productID: 56,
    unitPrice: 30.4,
    quantity: 5,
    discount: 0,
  },
  {
    orderID: 10426,
    productID: 64,
    unitPrice: 26.6,
    quantity: 7,
    discount: 0,
  },
  {
    orderID: 10427,
    productID: 14,
    unitPrice: 18.6,
    quantity: 35,
    discount: 0,
  },
  {
    orderID: 10428,
    productID: 46,
    unitPrice: 9.6,
    quantity: 20,
    discount: 0,
  },
  {
    orderID: 10429,
    productID: 50,
    unitPrice: 13,
    quantity: 40,
    discount: 0,
  },
  {
    orderID: 10429,
    productID: 63,
    unitPrice: 35.1,
    quantity: 35,
    discount: 0.25,
  },
  {
    orderID: 10430,
    productID: 17,
    unitPrice: 31.2,
    quantity: 45,
    discount: 0.2,
  },
  {
    orderID: 10430,
    productID: 21,
    unitPrice: 8,
    quantity: 50,
    discount: 0,
  },
  {
    orderID: 10430,
    productID: 56,
    unitPrice: 30.4,
    quantity: 30,
    discount: 0,
  },
  {
    orderID: 10430,
    productID: 59,
    unitPrice: 44,
    quantity: 70,
    discount: 0.2,
  },
  {
    orderID: 10431,
    productID: 17,
    unitPrice: 31.2,
    quantity: 50,
    discount: 0.25,
  },
  {
    orderID: 10431,
    productID: 40,
    unitPrice: 14.7,
    quantity: 50,
    discount: 0.25,
  },
  {
    orderID: 10431,
    productID: 47,
    unitPrice: 7.6,
    quantity: 30,
    discount: 0.25,
  },
  {
    orderID: 10432,
    productID: 26,
    unitPrice: 24.9,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10432,
    productID: 54,
    unitPrice: 5.9,
    quantity: 40,
    discount: 0,
  },
  {
    orderID: 10433,
    productID: 56,
    unitPrice: 30.4,
    quantity: 28,
    discount: 0,
  },
  {
    orderID: 10434,
    productID: 11,
    unitPrice: 16.8,
    quantity: 6,
    discount: 0,
  },
  {
    orderID: 10434,
    productID: 76,
    unitPrice: 14.4,
    quantity: 18,
    discount: 0.15,
  },
  {
    orderID: 10435,
    productID: 2,
    unitPrice: 15.2,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10435,
    productID: 22,
    unitPrice: 16.8,
    quantity: 12,
    discount: 0,
  },
  {
    orderID: 10435,
    productID: 72,
    unitPrice: 27.8,
    quantity: 10,
    discount: 0,
  },
  {
    orderID: 10436,
    productID: 46,
    unitPrice: 9.6,
    quantity: 5,
    discount: 0,
  },
  {
    orderID: 10436,
    productID: 56,
    unitPrice: 30.4,
    quantity: 40,
    discount: 0.1,
  },
  {
    orderID: 10436,
    productID: 64,
    unitPrice: 26.6,
    quantity: 30,
    discount: 0.1,
  },
  {
    orderID: 10436,
    productID: 75,
    unitPrice: 6.2,
    quantity: 24,
    discount: 0.1,
  },
  {
    orderID: 10437,
    productID: 53,
    unitPrice: 26.2,
    quantity: 15,
    discount: 0,
  },
];
const orders = [
  {
    orderID: 10840,
    customerID: "LINOD",
    employeeID: 4,
    orderDate: "1998-01-19 00:00:00.000",
    requiredDate: "1998-03-02 00:00:00.000",
    shippedDate: "1998-02-16 00:00:00.000",
    shipVia: 2,
    freight: 2.71,
    shipName: "LINO-Delicateses",
    shipAddress: "Ave. 5 de Mayo Porlamar",
    shipCity: "I. de Margarita",
    shipRegion: "Nueva Esparta",
    shipPostalCode: 4980,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10841,
    customerID: "SUPRD",
    employeeID: 5,
    orderDate: "1998-01-20 00:00:00.000",
    requiredDate: "1998-02-17 00:00:00.000",
    shippedDate: "1998-01-29 00:00:00.000",
    shipVia: 2,
    freight: 424.3,
    shipName: "Suprêmes délices",
    shipAddress: "Boulevard Tirou 255",
    shipCity: "Charleroi",
    shipRegion: "NULL",
    shipPostalCode: "B-6000",
    shipCountry: "Belgium",
  },
  {
    orderID: 10842,
    customerID: "TORTU",
    employeeID: 1,
    orderDate: "1998-01-20 00:00:00.000",
    requiredDate: "1998-02-17 00:00:00.000",
    shippedDate: "1998-01-29 00:00:00.000",
    shipVia: 3,
    freight: 54.42,
    shipName: "Tortuga Restaurante",
    shipAddress: "Avda. Azteca 123",
    shipCity: "México D.F.",
    shipRegion: "NULL",
    shipPostalCode: "05033",
    shipCountry: "Mexico",
  },
  {
    orderID: 10843,
    customerID: "VICTE",
    employeeID: 4,
    orderDate: "1998-01-21 00:00:00.000",
    requiredDate: "1998-02-18 00:00:00.000",
    shippedDate: "1998-01-26 00:00:00.000",
    shipVia: 2,
    freight: 9.26,
    shipName: "Victuailles en stock",
    shipAddress: "2 rue du Commerce",
    shipCity: "Lyon",
    shipRegion: "NULL",
    shipPostalCode: 69004,
    shipCountry: "France",
  },
  {
    orderID: 10844,
    customerID: "PICCO",
    employeeID: 8,
    orderDate: "1998-01-21 00:00:00.000",
    requiredDate: "1998-02-18 00:00:00.000",
    shippedDate: "1998-01-26 00:00:00.000",
    shipVia: 2,
    freight: 25.22,
    shipName: "Piccolo und mehr",
    shipAddress: "Geislweg 14",
    shipCity: "Salzburg",
    shipRegion: "NULL",
    shipPostalCode: 5020,
    shipCountry: "Austria",
  },
  {
    orderID: 10845,
    customerID: "QUICK",
    employeeID: 8,
    orderDate: "1998-01-21 00:00:00.000",
    requiredDate: "1998-02-04 00:00:00.000",
    shippedDate: "1998-01-30 00:00:00.000",
    shipVia: 1,
    freight: 212.98,
    shipName: "QUICK-Stop",
    shipAddress: "Taucherstraße 10",
    shipCity: "Cunewalde",
    shipRegion: "NULL",
    shipPostalCode: "01307",
    shipCountry: "Germany",
  },
  {
    orderID: 10846,
    customerID: "SUPRD",
    employeeID: 2,
    orderDate: "1998-01-22 00:00:00.000",
    requiredDate: "1998-03-05 00:00:00.000",
    shippedDate: "1998-01-23 00:00:00.000",
    shipVia: 3,
    freight: 56.46,
    shipName: "Suprêmes délices",
    shipAddress: "Boulevard Tirou 255",
    shipCity: "Charleroi",
    shipRegion: "NULL",
    shipPostalCode: "B-6000",
    shipCountry: "Belgium",
  },
  {
    orderID: 10847,
    customerID: "SAVEA",
    employeeID: 4,
    orderDate: "1998-01-22 00:00:00.000",
    requiredDate: "1998-02-05 00:00:00.000",
    shippedDate: "1998-02-10 00:00:00.000",
    shipVia: 3,
    freight: 487.57,
    shipName: "Save-a-lot Markets",
    shipAddress: "187 Suffolk Ln.",
    shipCity: "Boise",
    shipRegion: "ID",
    shipPostalCode: 83720,
    shipCountry: "USA",
  },
  {
    orderID: 10848,
    customerID: "CONSH",
    employeeID: 7,
    orderDate: "1998-01-23 00:00:00.000",
    requiredDate: "1998-02-20 00:00:00.000",
    shippedDate: "1998-01-29 00:00:00.000",
    shipVia: 2,
    freight: 38.24,
    shipName: "Consolidated Holdings",
    shipAddress: "Berkeley Gardens 12  Brewery",
    shipCity: "London",
    shipRegion: "NULL",
    shipPostalCode: "WX1 6LT",
    shipCountry: "UK",
  },
  {
    orderID: 10849,
    customerID: "KOENE",
    employeeID: 9,
    orderDate: "1998-01-23 00:00:00.000",
    requiredDate: "1998-02-20 00:00:00.000",
    shippedDate: "1998-01-30 00:00:00.000",
    shipVia: 2,
    freight: 0.56,
    shipName: "Königlich Essen",
    shipAddress: "Maubelstr. 90",
    shipCity: "Brandenburg",
    shipRegion: "NULL",
    shipPostalCode: 14776,
    shipCountry: "Germany",
  },
  {
    orderID: 10850,
    customerID: "VICTE",
    employeeID: 1,
    orderDate: "1998-01-23 00:00:00.000",
    requiredDate: "1998-03-06 00:00:00.000",
    shippedDate: "1998-01-30 00:00:00.000",
    shipVia: 1,
    freight: 49.19,
    shipName: "Victuailles en stock",
    shipAddress: "2 rue du Commerce",
    shipCity: "Lyon",
    shipRegion: "NULL",
    shipPostalCode: 69004,
    shipCountry: "France",
  },
  {
    orderID: 10851,
    customerID: "RICAR",
    employeeID: 5,
    orderDate: "1998-01-26 00:00:00.000",
    requiredDate: "1998-02-23 00:00:00.000",
    shippedDate: "1998-02-02 00:00:00.000",
    shipVia: 1,
    freight: 160.55,
    shipName: "Ricardo Adocicados",
    shipAddress: "Av. Copacabana 267",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "02389-890",
    shipCountry: "Brazil",
  },
  {
    orderID: 10852,
    customerID: "RATTC",
    employeeID: 8,
    orderDate: "1998-01-26 00:00:00.000",
    requiredDate: "1998-02-09 00:00:00.000",
    shippedDate: "1998-01-30 00:00:00.000",
    shipVia: 1,
    freight: 174.05,
    shipName: "Rattlesnake Canyon Grocery",
    shipAddress: "2817 Milton Dr.",
    shipCity: "Albuquerque",
    shipRegion: "NM",
    shipPostalCode: 87110,
    shipCountry: "USA",
  },
  {
    orderID: 10853,
    customerID: "BLAUS",
    employeeID: 9,
    orderDate: "1998-01-27 00:00:00.000",
    requiredDate: "1998-02-24 00:00:00.000",
    shippedDate: "1998-02-03 00:00:00.000",
    shipVia: 2,
    freight: 53.83,
    shipName: "Blauer See Delikatessen",
    shipAddress: "Forsterstr. 57",
    shipCity: "Mannheim",
    shipRegion: "NULL",
    shipPostalCode: 68306,
    shipCountry: "Germany",
  },
  {
    orderID: 10854,
    customerID: "ERNSH",
    employeeID: 3,
    orderDate: "1998-01-27 00:00:00.000",
    requiredDate: "1998-02-24 00:00:00.000",
    shippedDate: "1998-02-05 00:00:00.000",
    shipVia: 2,
    freight: 100.22,
    shipName: "Ernst Handel",
    shipAddress: "Kirchgasse 6",
    shipCity: "Graz",
    shipRegion: "NULL",
    shipPostalCode: 8010,
    shipCountry: "Austria",
  },
  {
    orderID: 10855,
    customerID: "OLDWO",
    employeeID: 3,
    orderDate: "1998-01-27 00:00:00.000",
    requiredDate: "1998-02-24 00:00:00.000",
    shippedDate: "1998-02-04 00:00:00.000",
    shipVia: 1,
    freight: 170.97,
    shipName: "Old World Delicatessen",
    shipAddress: "2743 Bering St.",
    shipCity: "Anchorage",
    shipRegion: "AK",
    shipPostalCode: 99508,
    shipCountry: "USA",
  },
  {
    orderID: 10856,
    customerID: "ANTON",
    employeeID: 3,
    orderDate: "1998-01-28 00:00:00.000",
    requiredDate: "1998-02-25 00:00:00.000",
    shippedDate: "1998-02-10 00:00:00.000",
    shipVia: 2,
    freight: 58.43,
    shipName: "Antonio Moreno Taquería",
    shipAddress: "Mataderos  2312",
    shipCity: "México D.F.",
    shipRegion: "NULL",
    shipPostalCode: "05023",
    shipCountry: "Mexico",
  },
  {
    orderID: 10857,
    customerID: "BERGS",
    employeeID: 8,
    orderDate: "1998-01-28 00:00:00.000",
    requiredDate: "1998-02-25 00:00:00.000",
    shippedDate: "1998-02-06 00:00:00.000",
    shipVia: 2,
    freight: 188.85,
    shipName: "Berglunds snabbköp",
    shipAddress: "Berguvsvägen  8",
    shipCity: "Luleå",
    shipRegion: "NULL",
    shipPostalCode: "S-958 22",
    shipCountry: "Sweden",
  },
  {
    orderID: 10858,
    customerID: "LACOR",
    employeeID: 2,
    orderDate: "1998-01-29 00:00:00.000",
    requiredDate: "1998-02-26 00:00:00.000",
    shippedDate: "1998-02-03 00:00:00.000",
    shipVia: 1,
    freight: 52.51,
    shipName: "La corne d'abondance",
    shipAddress: "67 avenue de l'Europe",
    shipCity: "Versailles",
    shipRegion: "NULL",
    shipPostalCode: 78000,
    shipCountry: "France",
  },
  {
    orderID: 10859,
    customerID: "FRANK",
    employeeID: 1,
    orderDate: "1998-01-29 00:00:00.000",
    requiredDate: "1998-02-26 00:00:00.000",
    shippedDate: "1998-02-02 00:00:00.000",
    shipVia: 2,
    freight: 76.1,
    shipName: "Frankenversand",
    shipAddress: "Berliner Platz 43",
    shipCity: "München",
    shipRegion: "NULL",
    shipPostalCode: 80805,
    shipCountry: "Germany",
  },
  {
    orderID: 10860,
    customerID: "FRANR",
    employeeID: 3,
    orderDate: "1998-01-29 00:00:00.000",
    requiredDate: "1998-02-26 00:00:00.000",
    shippedDate: "1998-02-04 00:00:00.000",
    shipVia: 3,
    freight: 19.26,
    shipName: "France restauration",
    shipAddress: "54 rue Royale",
    shipCity: "Nantes",
    shipRegion: "NULL",
    shipPostalCode: 44000,
    shipCountry: "France",
  },
  {
    orderID: 10861,
    customerID: "WHITC",
    employeeID: 4,
    orderDate: "1998-01-30 00:00:00.000",
    requiredDate: "1998-02-27 00:00:00.000",
    shippedDate: "1998-02-17 00:00:00.000",
    shipVia: 2,
    freight: 14.93,
    shipName: "White Clover Markets",
    shipAddress: "1029 - 12th Ave. S.",
    shipCity: "Seattle",
    shipRegion: "WA",
    shipPostalCode: 98124,
    shipCountry: "USA",
  },
  {
    orderID: 10862,
    customerID: "LEHMS",
    employeeID: 8,
    orderDate: "1998-01-30 00:00:00.000",
    requiredDate: "1998-03-13 00:00:00.000",
    shippedDate: "1998-02-02 00:00:00.000",
    shipVia: 2,
    freight: 53.23,
    shipName: "Lehmanns Marktstand",
    shipAddress: "Magazinweg 7",
    shipCity: "Frankfurt a.M.",
    shipRegion: "NULL",
    shipPostalCode: 60528,
    shipCountry: "Germany",
  },
  {
    orderID: 10863,
    customerID: "HILAA",
    employeeID: 4,
    orderDate: "1998-02-02 00:00:00.000",
    requiredDate: "1998-03-02 00:00:00.000",
    shippedDate: "1998-02-17 00:00:00.000",
    shipVia: 2,
    freight: 30.26,
    shipName: "HILARION-Abastos",
    shipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
    shipCity: "San Cristóbal",
    shipRegion: "Táchira",
    shipPostalCode: 5022,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10864,
    customerID: "AROUT",
    employeeID: 4,
    orderDate: "1998-02-02 00:00:00.000",
    requiredDate: "1998-03-02 00:00:00.000",
    shippedDate: "1998-02-09 00:00:00.000",
    shipVia: 2,
    freight: 3.04,
    shipName: "Around the Horn",
    shipAddress: "Brook Farm Stratford St. Mary",
    shipCity: "Colchester",
    shipRegion: "Essex",
    shipPostalCode: "CO7 6JX",
    shipCountry: "UK",
  },
  {
    orderID: 10865,
    customerID: "QUICK",
    employeeID: 2,
    orderDate: "1998-02-02 00:00:00.000",
    requiredDate: "1998-02-16 00:00:00.000",
    shippedDate: "1998-02-12 00:00:00.000",
    shipVia: 1,
    freight: 348.14,
    shipName: "QUICK-Stop",
    shipAddress: "Taucherstraße 10",
    shipCity: "Cunewalde",
    shipRegion: "NULL",
    shipPostalCode: "01307",
    shipCountry: "Germany",
  },
  {
    orderID: 10866,
    customerID: "BERGS",
    employeeID: 5,
    orderDate: "1998-02-03 00:00:00.000",
    requiredDate: "1998-03-03 00:00:00.000",
    shippedDate: "1998-02-12 00:00:00.000",
    shipVia: 1,
    freight: 109.11,
    shipName: "Berglunds snabbköp",
    shipAddress: "Berguvsvägen  8",
    shipCity: "Luleå",
    shipRegion: "NULL",
    shipPostalCode: "S-958 22",
    shipCountry: "Sweden",
  },
  {
    orderID: 10867,
    customerID: "LONEP",
    employeeID: 6,
    orderDate: "1998-02-03 00:00:00.000",
    requiredDate: "1998-03-17 00:00:00.000",
    shippedDate: "1998-02-11 00:00:00.000",
    shipVia: 1,
    freight: 1.93,
    shipName: "Lonesome Pine Restaurant",
    shipAddress: "89 Chiaroscuro Rd.",
    shipCity: "Portland",
    shipRegion: "OR",
    shipPostalCode: 97219,
    shipCountry: "USA",
  },
  {
    orderID: 10868,
    customerID: "QUEEN",
    employeeID: 7,
    orderDate: "1998-02-04 00:00:00.000",
    requiredDate: "1998-03-04 00:00:00.000",
    shippedDate: "1998-02-23 00:00:00.000",
    shipVia: 2,
    freight: 191.27,
    shipName: "Queen Cozinha",
    shipAddress: "Alameda dos Canàrios 891",
    shipCity: "Sao Paulo",
    shipRegion: "SP",
    shipPostalCode: "05487-020",
    shipCountry: "Brazil",
  },
  {
    orderID: 10869,
    customerID: "SEVES",
    employeeID: 5,
    orderDate: "1998-02-04 00:00:00.000",
    requiredDate: "1998-03-04 00:00:00.000",
    shippedDate: "1998-02-09 00:00:00.000",
    shipVia: 1,
    freight: 143.28,
    shipName: "Seven Seas Imports",
    shipAddress: "90 Wadhurst Rd.",
    shipCity: "London",
    shipRegion: "NULL",
    shipPostalCode: "OX15 4NB",
    shipCountry: "UK",
  },
  {
    orderID: 10870,
    customerID: "WOLZA",
    employeeID: 5,
    orderDate: "1998-02-04 00:00:00.000",
    requiredDate: "1998-03-04 00:00:00.000",
    shippedDate: "1998-02-13 00:00:00.000",
    shipVia: 3,
    freight: 12.04,
    shipName: "Wolski Zajazd",
    shipAddress: "ul. Filtrowa 68",
    shipCity: "Warszawa",
    shipRegion: "NULL",
    shipPostalCode: "01-012",
    shipCountry: "Poland",
  },
  {
    orderID: 10871,
    customerID: "BONAP",
    employeeID: 9,
    orderDate: "1998-02-05 00:00:00.000",
    requiredDate: "1998-03-05 00:00:00.000",
    shippedDate: "1998-02-10 00:00:00.000",
    shipVia: 2,
    freight: 112.27,
    shipName: "Bon app'",
    shipAddress: "12 rue des Bouchers",
    shipCity: "Marseille",
    shipRegion: "NULL",
    shipPostalCode: 13008,
    shipCountry: "France",
  },
  {
    orderID: 10872,
    customerID: "GODOS",
    employeeID: 5,
    orderDate: "1998-02-05 00:00:00.000",
    requiredDate: "1998-03-05 00:00:00.000",
    shippedDate: "1998-02-09 00:00:00.000",
    shipVia: 2,
    freight: 175.32,
    shipName: "Godos Cocina Típica",
    shipAddress: "C/ Romero 33",
    shipCity: "Sevilla",
    shipRegion: "NULL",
    shipPostalCode: 41101,
    shipCountry: "Spain",
  },
  {
    orderID: 10873,
    customerID: "WILMK",
    employeeID: 4,
    orderDate: "1998-02-06 00:00:00.000",
    requiredDate: "1998-03-06 00:00:00.000",
    shippedDate: "1998-02-09 00:00:00.000",
    shipVia: 1,
    freight: 0.82,
    shipName: "Wilman Kala",
    shipAddress: "Keskuskatu 45",
    shipCity: "Helsinki",
    shipRegion: "NULL",
    shipPostalCode: 21240,
    shipCountry: "Finland",
  },
  {
    orderID: 10874,
    customerID: "GODOS",
    employeeID: 5,
    orderDate: "1998-02-06 00:00:00.000",
    requiredDate: "1998-03-06 00:00:00.000",
    shippedDate: "1998-02-11 00:00:00.000",
    shipVia: 2,
    freight: 19.58,
    shipName: "Godos Cocina Típica",
    shipAddress: "C/ Romero 33",
    shipCity: "Sevilla",
    shipRegion: "NULL",
    shipPostalCode: 41101,
    shipCountry: "Spain",
  },
  {
    orderID: 10875,
    customerID: "BERGS",
    employeeID: 4,
    orderDate: "1998-02-06 00:00:00.000",
    requiredDate: "1998-03-06 00:00:00.000",
    shippedDate: "1998-03-03 00:00:00.000",
    shipVia: 2,
    freight: 32.37,
    shipName: "Berglunds snabbköp",
    shipAddress: "Berguvsvägen  8",
    shipCity: "Luleå",
    shipRegion: "NULL",
    shipPostalCode: "S-958 22",
    shipCountry: "Sweden",
  },
  {
    orderID: 10876,
    customerID: "BONAP",
    employeeID: 7,
    orderDate: "1998-02-09 00:00:00.000",
    requiredDate: "1998-03-09 00:00:00.000",
    shippedDate: "1998-02-12 00:00:00.000",
    shipVia: 3,
    freight: 60.42,
    shipName: "Bon app'",
    shipAddress: "12 rue des Bouchers",
    shipCity: "Marseille",
    shipRegion: "NULL",
    shipPostalCode: 13008,
    shipCountry: "France",
  },
  {
    orderID: 10877,
    customerID: "RICAR",
    employeeID: 1,
    orderDate: "1998-02-09 00:00:00.000",
    requiredDate: "1998-03-09 00:00:00.000",
    shippedDate: "1998-02-19 00:00:00.000",
    shipVia: 1,
    freight: 38.06,
    shipName: "Ricardo Adocicados",
    shipAddress: "Av. Copacabana 267",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "02389-890",
    shipCountry: "Brazil",
  },
  {
    orderID: 10878,
    customerID: "QUICK",
    employeeID: 4,
    orderDate: "1998-02-10 00:00:00.000",
    requiredDate: "1998-03-10 00:00:00.000",
    shippedDate: "1998-02-12 00:00:00.000",
    shipVia: 1,
    freight: 46.69,
    shipName: "QUICK-Stop",
    shipAddress: "Taucherstraße 10",
    shipCity: "Cunewalde",
    shipRegion: "NULL",
    shipPostalCode: "01307",
    shipCountry: "Germany",
  },
  {
    orderID: 10879,
    customerID: "WILMK",
    employeeID: 3,
    orderDate: "1998-02-10 00:00:00.000",
    requiredDate: "1998-03-10 00:00:00.000",
    shippedDate: "1998-02-12 00:00:00.000",
    shipVia: 3,
    freight: 8.5,
    shipName: "Wilman Kala",
    shipAddress: "Keskuskatu 45",
    shipCity: "Helsinki",
    shipRegion: "NULL",
    shipPostalCode: 21240,
    shipCountry: "Finland",
  },
  {
    orderID: 10880,
    customerID: "FOLKO",
    employeeID: 7,
    orderDate: "1998-02-10 00:00:00.000",
    requiredDate: "1998-03-24 00:00:00.000",
    shippedDate: "1998-02-18 00:00:00.000",
    shipVia: 1,
    freight: 88.01,
    shipName: "Folk och fä HB",
    shipAddress: "Åkergatan 24",
    shipCity: "Bräcke",
    shipRegion: "NULL",
    shipPostalCode: "S-844 67",
    shipCountry: "Sweden",
  },
  {
    orderID: 10881,
    customerID: "CACTU",
    employeeID: 4,
    orderDate: "1998-02-11 00:00:00.000",
    requiredDate: "1998-03-11 00:00:00.000",
    shippedDate: "1998-02-18 00:00:00.000",
    shipVia: 1,
    freight: 2.84,
    shipName: "Cactus Comidas para llevar",
    shipAddress: "Cerrito 333",
    shipCity: "Buenos Aires",
    shipRegion: "NULL",
    shipPostalCode: 1010,
    shipCountry: "Argentina",
  },
  {
    orderID: 10882,
    customerID: "SAVEA",
    employeeID: 4,
    orderDate: "1998-02-11 00:00:00.000",
    requiredDate: "1998-03-11 00:00:00.000",
    shippedDate: "1998-02-20 00:00:00.000",
    shipVia: 3,
    freight: 23.1,
    shipName: "Save-a-lot Markets",
    shipAddress: "187 Suffolk Ln.",
    shipCity: "Boise",
    shipRegion: "ID",
    shipPostalCode: 83720,
    shipCountry: "USA",
  },
  {
    orderID: 10883,
    customerID: "LONEP",
    employeeID: 8,
    orderDate: "1998-02-12 00:00:00.000",
    requiredDate: "1998-03-12 00:00:00.000",
    shippedDate: "1998-02-20 00:00:00.000",
    shipVia: 3,
    freight: 0.53,
    shipName: "Lonesome Pine Restaurant",
    shipAddress: "89 Chiaroscuro Rd.",
    shipCity: "Portland",
    shipRegion: "OR",
    shipPostalCode: 97219,
    shipCountry: "USA",
  },
  {
    orderID: 10884,
    customerID: "LETSS",
    employeeID: 4,
    orderDate: "1998-02-12 00:00:00.000",
    requiredDate: "1998-03-12 00:00:00.000",
    shippedDate: "1998-02-13 00:00:00.000",
    shipVia: 2,
    freight: 90.97,
    shipName: "Let's Stop N Shop",
    shipAddress: "87 Polk St. Suite 5",
    shipCity: "San Francisco",
    shipRegion: "CA",
    shipPostalCode: 94117,
    shipCountry: "USA",
  },
  {
    orderID: 10885,
    customerID: "SUPRD",
    employeeID: 6,
    orderDate: "1998-02-12 00:00:00.000",
    requiredDate: "1998-03-12 00:00:00.000",
    shippedDate: "1998-02-18 00:00:00.000",
    shipVia: 3,
    freight: 5.64,
    shipName: "Suprêmes délices",
    shipAddress: "Boulevard Tirou 255",
    shipCity: "Charleroi",
    shipRegion: "NULL",
    shipPostalCode: "B-6000",
    shipCountry: "Belgium",
  },
  {
    orderID: 10886,
    customerID: "HANAR",
    employeeID: 1,
    orderDate: "1998-02-13 00:00:00.000",
    requiredDate: "1998-03-13 00:00:00.000",
    shippedDate: "1998-03-02 00:00:00.000",
    shipVia: 1,
    freight: 4.99,
    shipName: "Hanari Carnes",
    shipAddress: "Rua do Paço 67",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "05454-876",
    shipCountry: "Brazil",
  },
  {
    orderID: 10887,
    customerID: "GALED",
    employeeID: 8,
    orderDate: "1998-02-13 00:00:00.000",
    requiredDate: "1998-03-13 00:00:00.000",
    shippedDate: "1998-02-16 00:00:00.000",
    shipVia: 3,
    freight: 1.25,
    shipName: "Galería del gastronómo",
    shipAddress: "Rambla de Cataluña 23",
    shipCity: "Barcelona",
    shipRegion: "NULL",
    shipPostalCode: 8022,
    shipCountry: "Spain",
  },
  {
    orderID: 10888,
    customerID: "GODOS",
    employeeID: 1,
    orderDate: "1998-02-16 00:00:00.000",
    requiredDate: "1998-03-16 00:00:00.000",
    shippedDate: "1998-02-23 00:00:00.000",
    shipVia: 2,
    freight: 51.87,
    shipName: "Godos Cocina Típica",
    shipAddress: "C/ Romero 33",
    shipCity: "Sevilla",
    shipRegion: "NULL",
    shipPostalCode: 41101,
    shipCountry: "Spain",
  },
  {
    orderID: 10889,
    customerID: "RATTC",
    employeeID: 9,
    orderDate: "1998-02-16 00:00:00.000",
    requiredDate: "1998-03-16 00:00:00.000",
    shippedDate: "1998-02-23 00:00:00.000",
    shipVia: 3,
    freight: 280.61,
    shipName: "Rattlesnake Canyon Grocery",
    shipAddress: "2817 Milton Dr.",
    shipCity: "Albuquerque",
    shipRegion: "NM",
    shipPostalCode: 87110,
    shipCountry: "USA",
  },
  {
    orderID: 10890,
    customerID: "DUMON",
    employeeID: 7,
    orderDate: "1998-02-16 00:00:00.000",
    requiredDate: "1998-03-16 00:00:00.000",
    shippedDate: "1998-02-18 00:00:00.000",
    shipVia: 1,
    freight: 32.76,
    shipName: "Du monde entier",
    shipAddress: "67 rue des Cinquante Otages",
    shipCity: "Nantes",
    shipRegion: "NULL",
    shipPostalCode: 44000,
    shipCountry: "France",
  },
  {
    orderID: 10891,
    customerID: "LEHMS",
    employeeID: 7,
    orderDate: "1998-02-17 00:00:00.000",
    requiredDate: "1998-03-17 00:00:00.000",
    shippedDate: "1998-02-19 00:00:00.000",
    shipVia: 2,
    freight: 20.37,
    shipName: "Lehmanns Marktstand",
    shipAddress: "Magazinweg 7",
    shipCity: "Frankfurt a.M.",
    shipRegion: "NULL",
    shipPostalCode: 60528,
    shipCountry: "Germany",
  },
  {
    orderID: 10892,
    customerID: "MAISD",
    employeeID: 4,
    orderDate: "1998-02-17 00:00:00.000",
    requiredDate: "1998-03-17 00:00:00.000",
    shippedDate: "1998-02-19 00:00:00.000",
    shipVia: 2,
    freight: 120.27,
    shipName: "Maison Dewey",
    shipAddress: "Rue Joseph-Bens 532",
    shipCity: "Bruxelles",
    shipRegion: "NULL",
    shipPostalCode: "B-1180",
    shipCountry: "Belgium",
  },
  {
    orderID: 10893,
    customerID: "KOENE",
    employeeID: 9,
    orderDate: "1998-02-18 00:00:00.000",
    requiredDate: "1998-03-18 00:00:00.000",
    shippedDate: "1998-02-20 00:00:00.000",
    shipVia: 2,
    freight: 77.78,
    shipName: "Königlich Essen",
    shipAddress: "Maubelstr. 90",
    shipCity: "Brandenburg",
    shipRegion: "NULL",
    shipPostalCode: 14776,
    shipCountry: "Germany",
  },
  {
    orderID: 10894,
    customerID: "SAVEA",
    employeeID: 1,
    orderDate: "1998-02-18 00:00:00.000",
    requiredDate: "1998-03-18 00:00:00.000",
    shippedDate: "1998-02-20 00:00:00.000",
    shipVia: 1,
    freight: 116.13,
    shipName: "Save-a-lot Markets",
    shipAddress: "187 Suffolk Ln.",
    shipCity: "Boise",
    shipRegion: "ID",
    shipPostalCode: 83720,
    shipCountry: "USA",
  },
  {
    orderID: 10895,
    customerID: "ERNSH",
    employeeID: 3,
    orderDate: "1998-02-18 00:00:00.000",
    requiredDate: "1998-03-18 00:00:00.000",
    shippedDate: "1998-02-23 00:00:00.000",
    shipVia: 1,
    freight: 162.75,
    shipName: "Ernst Handel",
    shipAddress: "Kirchgasse 6",
    shipCity: "Graz",
    shipRegion: "NULL",
    shipPostalCode: 8010,
    shipCountry: "Austria",
  },
  {
    orderID: 10896,
    customerID: "MAISD",
    employeeID: 7,
    orderDate: "1998-02-19 00:00:00.000",
    requiredDate: "1998-03-19 00:00:00.000",
    shippedDate: "1998-02-27 00:00:00.000",
    shipVia: 3,
    freight: 32.45,
    shipName: "Maison Dewey",
    shipAddress: "Rue Joseph-Bens 532",
    shipCity: "Bruxelles",
    shipRegion: "NULL",
    shipPostalCode: "B-1180",
    shipCountry: "Belgium",
  },
  {
    orderID: 10897,
    customerID: "HUNGO",
    employeeID: 3,
    orderDate: "1998-02-19 00:00:00.000",
    requiredDate: "1998-03-19 00:00:00.000",
    shippedDate: "1998-02-25 00:00:00.000",
    shipVia: 2,
    freight: 603.54,
    shipName: "Hungry Owl All-Night Grocers",
    shipAddress: "8 Johnstown Road",
    shipCity: "Cork",
    shipRegion: "Co. Cork",
    shipPostalCode: "NULL",
    shipCountry: "Ireland",
  },
  {
    orderID: 10898,
    customerID: "OCEAN",
    employeeID: 4,
    orderDate: "1998-02-20 00:00:00.000",
    requiredDate: "1998-03-20 00:00:00.000",
    shippedDate: "1998-03-06 00:00:00.000",
    shipVia: 2,
    freight: 1.27,
    shipName: "Océano Atlántico Ltda.",
    shipAddress: "Ing. Gustavo Moncada 8585 Piso 20-A",
    shipCity: "Buenos Aires",
    shipRegion: "NULL",
    shipPostalCode: 1010,
    shipCountry: "Argentina",
  },
  {
    orderID: 10899,
    customerID: "LILAS",
    employeeID: 5,
    orderDate: "1998-02-20 00:00:00.000",
    requiredDate: "1998-03-20 00:00:00.000",
    shippedDate: "1998-02-26 00:00:00.000",
    shipVia: 3,
    freight: 1.21,
    shipName: "LILA-Supermercado",
    shipAddress: "Carrera 52 con Ave. Bolívar #65-98 Llano Largo",
    shipCity: "Barquisimeto",
    shipRegion: "Lara",
    shipPostalCode: 3508,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10900,
    customerID: "WELLI",
    employeeID: 1,
    orderDate: "1998-02-20 00:00:00.000",
    requiredDate: "1998-03-20 00:00:00.000",
    shippedDate: "1998-03-04 00:00:00.000",
    shipVia: 2,
    freight: 1.66,
    shipName: "Wellington Importadora",
    shipAddress: "Rua do Mercado 12",
    shipCity: "Resende",
    shipRegion: "SP",
    shipPostalCode: "08737-363",
    shipCountry: "Brazil",
  },
  {
    orderID: 10901,
    customerID: "HILAA",
    employeeID: 4,
    orderDate: "1998-02-23 00:00:00.000",
    requiredDate: "1998-03-23 00:00:00.000",
    shippedDate: "1998-02-26 00:00:00.000",
    shipVia: 1,
    freight: 62.09,
    shipName: "HILARION-Abastos",
    shipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
    shipCity: "San Cristóbal",
    shipRegion: "Táchira",
    shipPostalCode: 5022,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10902,
    customerID: "FOLKO",
    employeeID: 1,
    orderDate: "1998-02-23 00:00:00.000",
    requiredDate: "1998-03-23 00:00:00.000",
    shippedDate: "1998-03-03 00:00:00.000",
    shipVia: 1,
    freight: 44.15,
    shipName: "Folk och fä HB",
    shipAddress: "Åkergatan 24",
    shipCity: "Bräcke",
    shipRegion: "NULL",
    shipPostalCode: "S-844 67",
    shipCountry: "Sweden",
  },
  {
    orderID: 10903,
    customerID: "HANAR",
    employeeID: 3,
    orderDate: "1998-02-24 00:00:00.000",
    requiredDate: "1998-03-24 00:00:00.000",
    shippedDate: "1998-03-04 00:00:00.000",
    shipVia: 3,
    freight: 36.71,
    shipName: "Hanari Carnes",
    shipAddress: "Rua do Paço 67",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "05454-876",
    shipCountry: "Brazil",
  },
  {
    orderID: 10904,
    customerID: "WHITC",
    employeeID: 3,
    orderDate: "1998-02-24 00:00:00.000",
    requiredDate: "1998-03-24 00:00:00.000",
    shippedDate: "1998-02-27 00:00:00.000",
    shipVia: 3,
    freight: 162.95,
    shipName: "White Clover Markets",
    shipAddress: "1029 - 12th Ave. S.",
    shipCity: "Seattle",
    shipRegion: "WA",
    shipPostalCode: 98124,
    shipCountry: "USA",
  },
  {
    orderID: 10905,
    customerID: "WELLI",
    employeeID: 9,
    orderDate: "1998-02-24 00:00:00.000",
    requiredDate: "1998-03-24 00:00:00.000",
    shippedDate: "1998-03-06 00:00:00.000",
    shipVia: 2,
    freight: 13.72,
    shipName: "Wellington Importadora",
    shipAddress: "Rua do Mercado 12",
    shipCity: "Resende",
    shipRegion: "SP",
    shipPostalCode: "08737-363",
    shipCountry: "Brazil",
  },
  {
    orderID: 10906,
    customerID: "WOLZA",
    employeeID: 4,
    orderDate: "1998-02-25 00:00:00.000",
    requiredDate: "1998-03-11 00:00:00.000",
    shippedDate: "1998-03-03 00:00:00.000",
    shipVia: 3,
    freight: 26.29,
    shipName: "Wolski Zajazd",
    shipAddress: "ul. Filtrowa 68",
    shipCity: "Warszawa",
    shipRegion: "NULL",
    shipPostalCode: "01-012",
    shipCountry: "Poland",
  },
  {
    orderID: 10907,
    customerID: "SPECD",
    employeeID: 6,
    orderDate: "1998-02-25 00:00:00.000",
    requiredDate: "1998-03-25 00:00:00.000",
    shippedDate: "1998-02-27 00:00:00.000",
    shipVia: 3,
    freight: 9.19,
    shipName: "Spécialités du monde",
    shipAddress: "25 rue Lauriston",
    shipCity: "Paris",
    shipRegion: "NULL",
    shipPostalCode: 75016,
    shipCountry: "France",
  },
  {
    orderID: 10908,
    customerID: "REGGC",
    employeeID: 4,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-06 00:00:00.000",
    shipVia: 2,
    freight: 32.96,
    shipName: "Reggiani Caseifici",
    shipAddress: "Strada Provinciale 124",
    shipCity: "Reggio Emilia",
    shipRegion: "NULL",
    shipPostalCode: 42100,
    shipCountry: "Italy",
  },
  {
    orderID: 10909,
    customerID: "SANTG",
    employeeID: 1,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-10 00:00:00.000",
    shipVia: 2,
    freight: 53.05,
    shipName: "Santé Gourmet",
    shipAddress: "Erling Skakkes gate 78",
    shipCity: "Stavern",
    shipRegion: "NULL",
    shipPostalCode: 4110,
    shipCountry: "Norway",
  },
  {
    orderID: 10910,
    customerID: "WILMK",
    employeeID: 1,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-04 00:00:00.000",
    shipVia: 3,
    freight: 38.11,
    shipName: "Wilman Kala",
    shipAddress: "Keskuskatu 45",
    shipCity: "Helsinki",
    shipRegion: "NULL",
    shipPostalCode: 21240,
    shipCountry: "Finland",
  },
  {
    orderID: 10911,
    customerID: "GODOS",
    employeeID: 3,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-05 00:00:00.000",
    shipVia: 1,
    freight: 38.19,
    shipName: "Godos Cocina Típica",
    shipAddress: "C/ Romero 33",
    shipCity: "Sevilla",
    shipRegion: "NULL",
    shipPostalCode: 41101,
    shipCountry: "Spain",
  },
  {
    orderID: 10912,
    customerID: "HUNGO",
    employeeID: 2,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 2,
    freight: 580.91,
    shipName: "Hungry Owl All-Night Grocers",
    shipAddress: "8 Johnstown Road",
    shipCity: "Cork",
    shipRegion: "Co. Cork",
    shipPostalCode: "NULL",
    shipCountry: "Ireland",
  },
  {
    orderID: 10913,
    customerID: "QUEEN",
    employeeID: 4,
    orderDate: "1998-02-26 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-04 00:00:00.000",
    shipVia: 1,
    freight: 33.05,
    shipName: "Queen Cozinha",
    shipAddress: "Alameda dos Canàrios 891",
    shipCity: "Sao Paulo",
    shipRegion: "SP",
    shipPostalCode: "05487-020",
    shipCountry: "Brazil",
  },
  {
    orderID: 10914,
    customerID: "QUEEN",
    employeeID: 6,
    orderDate: "1998-02-27 00:00:00.000",
    requiredDate: "1998-03-27 00:00:00.000",
    shippedDate: "1998-03-02 00:00:00.000",
    shipVia: 1,
    freight: 21.19,
    shipName: "Queen Cozinha",
    shipAddress: "Alameda dos Canàrios 891",
    shipCity: "Sao Paulo",
    shipRegion: "SP",
    shipPostalCode: "05487-020",
    shipCountry: "Brazil",
  },
  {
    orderID: 10915,
    customerID: "TORTU",
    employeeID: 2,
    orderDate: "1998-02-27 00:00:00.000",
    requiredDate: "1998-03-27 00:00:00.000",
    shippedDate: "1998-03-02 00:00:00.000",
    shipVia: 2,
    freight: 3.51,
    shipName: "Tortuga Restaurante",
    shipAddress: "Avda. Azteca 123",
    shipCity: "México D.F.",
    shipRegion: "NULL",
    shipPostalCode: "05033",
    shipCountry: "Mexico",
  },
  {
    orderID: 10916,
    customerID: "RANCH",
    employeeID: 1,
    orderDate: "1998-02-27 00:00:00.000",
    requiredDate: "1998-03-27 00:00:00.000",
    shippedDate: "1998-03-09 00:00:00.000",
    shipVia: 2,
    freight: 63.77,
    shipName: "Rancho grande",
    shipAddress: "Av. del Libertador 900",
    shipCity: "Buenos Aires",
    shipRegion: "NULL",
    shipPostalCode: 1010,
    shipCountry: "Argentina",
  },
  {
    orderID: 10917,
    customerID: "ROMEY",
    employeeID: 4,
    orderDate: "1998-03-02 00:00:00.000",
    requiredDate: "1998-03-30 00:00:00.000",
    shippedDate: "1998-03-11 00:00:00.000",
    shipVia: 2,
    freight: 8.29,
    shipName: "Romero y tomillo",
    shipAddress: "Gran Vía 1",
    shipCity: "Madrid",
    shipRegion: "NULL",
    shipPostalCode: 28001,
    shipCountry: "Spain",
  },
  {
    orderID: 10918,
    customerID: "BOTTM",
    employeeID: 3,
    orderDate: "1998-03-02 00:00:00.000",
    requiredDate: "1998-03-30 00:00:00.000",
    shippedDate: "1998-03-11 00:00:00.000",
    shipVia: 3,
    freight: 48.83,
    shipName: "Bottom-Dollar Markets",
    shipAddress: "23 Tsawassen Blvd.",
    shipCity: "Tsawassen",
    shipRegion: "BC",
    shipPostalCode: "T2F 8M4",
    shipCountry: "Canada",
  },
  {
    orderID: 10919,
    customerID: "LINOD",
    employeeID: 2,
    orderDate: "1998-03-02 00:00:00.000",
    requiredDate: "1998-03-30 00:00:00.000",
    shippedDate: "1998-03-04 00:00:00.000",
    shipVia: 2,
    freight: 19.8,
    shipName: "LINO-Delicateses",
    shipAddress: "Ave. 5 de Mayo Porlamar",
    shipCity: "I. de Margarita",
    shipRegion: "Nueva Esparta",
    shipPostalCode: 4980,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10920,
    customerID: "AROUT",
    employeeID: 4,
    orderDate: "1998-03-03 00:00:00.000",
    requiredDate: "1998-03-31 00:00:00.000",
    shippedDate: "1998-03-09 00:00:00.000",
    shipVia: 2,
    freight: 29.61,
    shipName: "Around the Horn",
    shipAddress: "Brook Farm Stratford St. Mary",
    shipCity: "Colchester",
    shipRegion: "Essex",
    shipPostalCode: "CO7 6JX",
    shipCountry: "UK",
  },
  {
    orderID: 10921,
    customerID: "VAFFE",
    employeeID: 1,
    orderDate: "1998-03-03 00:00:00.000",
    requiredDate: "1998-04-14 00:00:00.000",
    shippedDate: "1998-03-09 00:00:00.000",
    shipVia: 1,
    freight: 176.48,
    shipName: "Vaffeljernet",
    shipAddress: "Smagsloget 45",
    shipCity: "Århus",
    shipRegion: "NULL",
    shipPostalCode: 8200,
    shipCountry: "Denmark",
  },
  {
    orderID: 10922,
    customerID: "HANAR",
    employeeID: 5,
    orderDate: "1998-03-03 00:00:00.000",
    requiredDate: "1998-03-31 00:00:00.000",
    shippedDate: "1998-03-05 00:00:00.000",
    shipVia: 3,
    freight: 62.74,
    shipName: "Hanari Carnes",
    shipAddress: "Rua do Paço 67",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "05454-876",
    shipCountry: "Brazil",
  },
  {
    orderID: 10923,
    customerID: "LAMAI",
    employeeID: 7,
    orderDate: "1998-03-03 00:00:00.000",
    requiredDate: "1998-04-14 00:00:00.000",
    shippedDate: "1998-03-13 00:00:00.000",
    shipVia: 3,
    freight: 68.26,
    shipName: "La maison d'Asie",
    shipAddress: "1 rue Alsace-Lorraine",
    shipCity: "Toulouse",
    shipRegion: "NULL",
    shipPostalCode: 31000,
    shipCountry: "France",
  },
  {
    orderID: 10924,
    customerID: "BERGS",
    employeeID: 3,
    orderDate: "1998-03-04 00:00:00.000",
    requiredDate: "1998-04-01 00:00:00.000",
    shippedDate: "1998-04-08 00:00:00.000",
    shipVia: 2,
    freight: 151.52,
    shipName: "Berglunds snabbköp",
    shipAddress: "Berguvsvägen  8",
    shipCity: "Luleå",
    shipRegion: "NULL",
    shipPostalCode: "S-958 22",
    shipCountry: "Sweden",
  },
  {
    orderID: 10925,
    customerID: "HANAR",
    employeeID: 3,
    orderDate: "1998-03-04 00:00:00.000",
    requiredDate: "1998-04-01 00:00:00.000",
    shippedDate: "1998-03-13 00:00:00.000",
    shipVia: 1,
    freight: 2.27,
    shipName: "Hanari Carnes",
    shipAddress: "Rua do Paço 67",
    shipCity: "Rio de Janeiro",
    shipRegion: "RJ",
    shipPostalCode: "05454-876",
    shipCountry: "Brazil",
  },
  {
    orderID: 10926,
    customerID: "ANATR",
    employeeID: 4,
    orderDate: "1998-03-04 00:00:00.000",
    requiredDate: "1998-04-01 00:00:00.000",
    shippedDate: "1998-03-11 00:00:00.000",
    shipVia: 3,
    freight: 39.92,
    shipName: "Ana Trujillo Emparedados y helados",
    shipAddress: "Avda. de la Constitución 2222",
    shipCity: "México D.F.",
    shipRegion: "NULL",
    shipPostalCode: "05021",
    shipCountry: "Mexico",
  },
  {
    orderID: 10927,
    customerID: "LACOR",
    employeeID: 4,
    orderDate: "1998-03-05 00:00:00.000",
    requiredDate: "1998-04-02 00:00:00.000",
    shippedDate: "1998-04-08 00:00:00.000",
    shipVia: 1,
    freight: 19.79,
    shipName: "La corne d'abondance",
    shipAddress: "67 avenue de l'Europe",
    shipCity: "Versailles",
    shipRegion: "NULL",
    shipPostalCode: 78000,
    shipCountry: "France",
  },
  {
    orderID: 10928,
    customerID: "GALED",
    employeeID: 1,
    orderDate: "1998-03-05 00:00:00.000",
    requiredDate: "1998-04-02 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 1,
    freight: 1.36,
    shipName: "Galería del gastronómo",
    shipAddress: "Rambla de Cataluña 23",
    shipCity: "Barcelona",
    shipRegion: "NULL",
    shipPostalCode: 8022,
    shipCountry: "Spain",
  },
  {
    orderID: 10929,
    customerID: "FRANK",
    employeeID: 6,
    orderDate: "1998-03-05 00:00:00.000",
    requiredDate: "1998-04-02 00:00:00.000",
    shippedDate: "1998-03-12 00:00:00.000",
    shipVia: 1,
    freight: 33.93,
    shipName: "Frankenversand",
    shipAddress: "Berliner Platz 43",
    shipCity: "München",
    shipRegion: "NULL",
    shipPostalCode: 80805,
    shipCountry: "Germany",
  },
  {
    orderID: 10930,
    customerID: "SUPRD",
    employeeID: 4,
    orderDate: "1998-03-06 00:00:00.000",
    requiredDate: "1998-04-17 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 3,
    freight: 15.55,
    shipName: "Suprêmes délices",
    shipAddress: "Boulevard Tirou 255",
    shipCity: "Charleroi",
    shipRegion: "NULL",
    shipPostalCode: "B-6000",
    shipCountry: "Belgium",
  },
  {
    orderID: 10931,
    customerID: "RICSU",
    employeeID: 4,
    orderDate: "1998-03-06 00:00:00.000",
    requiredDate: "1998-03-20 00:00:00.000",
    shippedDate: "1998-03-19 00:00:00.000",
    shipVia: 2,
    freight: 13.6,
    shipName: "Richter Supermarkt",
    shipAddress: "Starenweg 5",
    shipCity: "Genève",
    shipRegion: "NULL",
    shipPostalCode: 1204,
    shipCountry: "Switzerland",
  },
  {
    orderID: 10932,
    customerID: "BONAP",
    employeeID: 8,
    orderDate: "1998-03-06 00:00:00.000",
    requiredDate: "1998-04-03 00:00:00.000",
    shippedDate: "1998-03-24 00:00:00.000",
    shipVia: 1,
    freight: 134.64,
    shipName: "Bon app'",
    shipAddress: "12 rue des Bouchers",
    shipCity: "Marseille",
    shipRegion: "NULL",
    shipPostalCode: 13008,
    shipCountry: "France",
  },
  {
    orderID: 10933,
    customerID: "ISLAT",
    employeeID: 6,
    orderDate: "1998-03-06 00:00:00.000",
    requiredDate: "1998-04-03 00:00:00.000",
    shippedDate: "1998-03-16 00:00:00.000",
    shipVia: 3,
    freight: 54.15,
    shipName: "Island Trading",
    shipAddress: "Garden House Crowther Way",
    shipCity: "Cowes",
    shipRegion: "Isle of Wight",
    shipPostalCode: "PO31 7PJ",
    shipCountry: "UK",
  },
  {
    orderID: 10934,
    customerID: "LEHMS",
    employeeID: 3,
    orderDate: "1998-03-09 00:00:00.000",
    requiredDate: "1998-04-06 00:00:00.000",
    shippedDate: "1998-03-12 00:00:00.000",
    shipVia: 3,
    freight: 32.01,
    shipName: "Lehmanns Marktstand",
    shipAddress: "Magazinweg 7",
    shipCity: "Frankfurt a.M.",
    shipRegion: "NULL",
    shipPostalCode: 60528,
    shipCountry: "Germany",
  },
  {
    orderID: 10935,
    customerID: "WELLI",
    employeeID: 4,
    orderDate: "1998-03-09 00:00:00.000",
    requiredDate: "1998-04-06 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 3,
    freight: 47.59,
    shipName: "Wellington Importadora",
    shipAddress: "Rua do Mercado 12",
    shipCity: "Resende",
    shipRegion: "SP",
    shipPostalCode: "08737-363",
    shipCountry: "Brazil",
  },
  {
    orderID: 10936,
    customerID: "GREAL",
    employeeID: 3,
    orderDate: "1998-03-09 00:00:00.000",
    requiredDate: "1998-04-06 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 2,
    freight: 33.68,
    shipName: "Great Lakes Food Market",
    shipAddress: "2732 Baker Blvd.",
    shipCity: "Eugene",
    shipRegion: "OR",
    shipPostalCode: 97403,
    shipCountry: "USA",
  },
  {
    orderID: 10937,
    customerID: "CACTU",
    employeeID: 7,
    orderDate: "1998-03-10 00:00:00.000",
    requiredDate: "1998-03-24 00:00:00.000",
    shippedDate: "1998-03-13 00:00:00.000",
    shipVia: 3,
    freight: 31.51,
    shipName: "Cactus Comidas para llevar",
    shipAddress: "Cerrito 333",
    shipCity: "Buenos Aires",
    shipRegion: "NULL",
    shipPostalCode: 1010,
    shipCountry: "Argentina",
  },
  {
    orderID: 10938,
    customerID: "QUICK",
    employeeID: 3,
    orderDate: "1998-03-10 00:00:00.000",
    requiredDate: "1998-04-07 00:00:00.000",
    shippedDate: "1998-03-16 00:00:00.000",
    shipVia: 2,
    freight: 31.89,
    shipName: "QUICK-Stop",
    shipAddress: "Taucherstraße 10",
    shipCity: "Cunewalde",
    shipRegion: "NULL",
    shipPostalCode: "01307",
    shipCountry: "Germany",
  },
  {
    orderID: 10939,
    customerID: "MAGAA",
    employeeID: 2,
    orderDate: "1998-03-10 00:00:00.000",
    requiredDate: "1998-04-07 00:00:00.000",
    shippedDate: "1998-03-13 00:00:00.000",
    shipVia: 2,
    freight: 76.33,
    shipName: "Magazzini Alimentari Riuniti",
    shipAddress: "Via Ludovico il Moro 22",
    shipCity: "Bergamo",
    shipRegion: "NULL",
    shipPostalCode: 24100,
    shipCountry: "Italy",
  },
  {
    orderID: 10940,
    customerID: "BONAP",
    employeeID: 8,
    orderDate: "1998-03-11 00:00:00.000",
    requiredDate: "1998-04-08 00:00:00.000",
    shippedDate: "1998-03-23 00:00:00.000",
    shipVia: 3,
    freight: 19.77,
    shipName: "Bon app'",
    shipAddress: "12 rue des Bouchers",
    shipCity: "Marseille",
    shipRegion: "NULL",
    shipPostalCode: 13008,
    shipCountry: "France",
  },
  {
    orderID: 10941,
    customerID: "SAVEA",
    employeeID: 7,
    orderDate: "1998-03-11 00:00:00.000",
    requiredDate: "1998-04-08 00:00:00.000",
    shippedDate: "1998-03-20 00:00:00.000",
    shipVia: 2,
    freight: 400.81,
    shipName: "Save-a-lot Markets",
    shipAddress: "187 Suffolk Ln.",
    shipCity: "Boise",
    shipRegion: "ID",
    shipPostalCode: 83720,
    shipCountry: "USA",
  },
  {
    orderID: 10942,
    customerID: "REGGC",
    employeeID: 9,
    orderDate: "1998-03-11 00:00:00.000",
    requiredDate: "1998-04-08 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 3,
    freight: 17.95,
    shipName: "Reggiani Caseifici",
    shipAddress: "Strada Provinciale 124",
    shipCity: "Reggio Emilia",
    shipRegion: "NULL",
    shipPostalCode: 42100,
    shipCountry: "Italy",
  },
  {
    orderID: 10943,
    customerID: "BSBEV",
    employeeID: 4,
    orderDate: "1998-03-11 00:00:00.000",
    requiredDate: "1998-04-08 00:00:00.000",
    shippedDate: "1998-03-19 00:00:00.000",
    shipVia: 2,
    freight: 2.17,
    shipName: "B's Beverages",
    shipAddress: "Fauntleroy Circus",
    shipCity: "London",
    shipRegion: "NULL",
    shipPostalCode: "EC2 5NT",
    shipCountry: "UK",
  },
  {
    orderID: 10944,
    customerID: "BOTTM",
    employeeID: 6,
    orderDate: "1998-03-12 00:00:00.000",
    requiredDate: "1998-03-26 00:00:00.000",
    shippedDate: "1998-03-13 00:00:00.000",
    shipVia: 3,
    freight: 52.92,
    shipName: "Bottom-Dollar Markets",
    shipAddress: "23 Tsawassen Blvd.",
    shipCity: "Tsawassen",
    shipRegion: "BC",
    shipPostalCode: "T2F 8M4",
    shipCountry: "Canada",
  },
  {
    orderID: 10945,
    customerID: "MORGK",
    employeeID: 4,
    orderDate: "1998-03-12 00:00:00.000",
    requiredDate: "1998-04-09 00:00:00.000",
    shippedDate: "1998-03-18 00:00:00.000",
    shipVia: 1,
    freight: 10.22,
    shipName: "Morgenstern Gesundkost",
    shipAddress: "Heerstr. 22",
    shipCity: "Leipzig",
    shipRegion: "NULL",
    shipPostalCode: "04179",
    shipCountry: "Germany",
  },
  {
    orderID: 10946,
    customerID: "VAFFE",
    employeeID: 1,
    orderDate: "1998-03-12 00:00:00.000",
    requiredDate: "1998-04-09 00:00:00.000",
    shippedDate: "1998-03-19 00:00:00.000",
    shipVia: 2,
    freight: 27.2,
    shipName: "Vaffeljernet",
    shipAddress: "Smagsloget 45",
    shipCity: "Århus",
    shipRegion: "NULL",
    shipPostalCode: 8200,
    shipCountry: "Denmark",
  },
  {
    orderID: 10947,
    customerID: "BSBEV",
    employeeID: 3,
    orderDate: "1998-03-13 00:00:00.000",
    requiredDate: "1998-04-10 00:00:00.000",
    shippedDate: "1998-03-16 00:00:00.000",
    shipVia: 2,
    freight: 3.26,
    shipName: "B's Beverages",
    shipAddress: "Fauntleroy Circus",
    shipCity: "London",
    shipRegion: "NULL",
    shipPostalCode: "EC2 5NT",
    shipCountry: "UK",
  },
  {
    orderID: 10948,
    customerID: "GODOS",
    employeeID: 3,
    orderDate: "1998-03-13 00:00:00.000",
    requiredDate: "1998-04-10 00:00:00.000",
    shippedDate: "1998-03-19 00:00:00.000",
    shipVia: 3,
    freight: 23.39,
    shipName: "Godos Cocina Típica",
    shipAddress: "C/ Romero 33",
    shipCity: "Sevilla",
    shipRegion: "NULL",
    shipPostalCode: 41101,
    shipCountry: "Spain",
  },
  {
    orderID: 10949,
    customerID: "BOTTM",
    employeeID: 2,
    orderDate: "1998-03-13 00:00:00.000",
    requiredDate: "1998-04-10 00:00:00.000",
    shippedDate: "1998-03-17 00:00:00.000",
    shipVia: 3,
    freight: 74.44,
    shipName: "Bottom-Dollar Markets",
    shipAddress: "23 Tsawassen Blvd.",
    shipCity: "Tsawassen",
    shipRegion: "BC",
    shipPostalCode: "T2F 8M4",
    shipCountry: "Canada",
  },
  {
    orderID: 10950,
    customerID: "MAGAA",
    employeeID: 1,
    orderDate: "1998-03-16 00:00:00.000",
    requiredDate: "1998-04-13 00:00:00.000",
    shippedDate: "1998-03-23 00:00:00.000",
    shipVia: 2,
    freight: 2.5,
    shipName: "Magazzini Alimentari Riuniti",
    shipAddress: "Via Ludovico il Moro 22",
    shipCity: "Bergamo",
    shipRegion: "NULL",
    shipPostalCode: 24100,
    shipCountry: "Italy",
  },
  {
    orderID: 10951,
    customerID: "RICSU",
    employeeID: 9,
    orderDate: "1998-03-16 00:00:00.000",
    requiredDate: "1998-04-27 00:00:00.000",
    shippedDate: "1998-04-07 00:00:00.000",
    shipVia: 2,
    freight: 30.85,
    shipName: "Richter Supermarkt",
    shipAddress: "Starenweg 5",
    shipCity: "Genève",
    shipRegion: "NULL",
    shipPostalCode: 1204,
    shipCountry: "Switzerland",
  },
  {
    orderID: 10952,
    customerID: "ALFKI",
    employeeID: 1,
    orderDate: "1998-03-16 00:00:00.000",
    requiredDate: "1998-04-27 00:00:00.000",
    shippedDate: "1998-03-24 00:00:00.000",
    shipVia: 1,
    freight: 40.42,
    shipName: "Alfred's Futterkiste",
    shipAddress: "Obere Str. 57",
    shipCity: "Berlin",
    shipRegion: "NULL",
    shipPostalCode: 12209,
    shipCountry: "Germany",
  },
  {
    orderID: 10953,
    customerID: "AROUT",
    employeeID: 9,
    orderDate: "1998-03-16 00:00:00.000",
    requiredDate: "1998-03-30 00:00:00.000",
    shippedDate: "1998-03-25 00:00:00.000",
    shipVia: 2,
    freight: 23.72,
    shipName: "Around the Horn",
    shipAddress: "Brook Farm Stratford St. Mary",
    shipCity: "Colchester",
    shipRegion: "Essex",
    shipPostalCode: "CO7 6JX",
    shipCountry: "UK",
  },
  {
    orderID: 10954,
    customerID: "LINOD",
    employeeID: 5,
    orderDate: "1998-03-17 00:00:00.000",
    requiredDate: "1998-04-28 00:00:00.000",
    shippedDate: "1998-03-20 00:00:00.000",
    shipVia: 1,
    freight: 27.91,
    shipName: "LINO-Delicateses",
    shipAddress: "Ave. 5 de Mayo Porlamar",
    shipCity: "I. de Margarita",
    shipRegion: "Nueva Esparta",
    shipPostalCode: 4980,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10955,
    customerID: "FOLKO",
    employeeID: 8,
    orderDate: "1998-03-17 00:00:00.000",
    requiredDate: "1998-04-14 00:00:00.000",
    shippedDate: "1998-03-20 00:00:00.000",
    shipVia: 2,
    freight: 3.26,
    shipName: "Folk och fä HB",
    shipAddress: "Åkergatan 24",
    shipCity: "Bräcke",
    shipRegion: "NULL",
    shipPostalCode: "S-844 67",
    shipCountry: "Sweden",
  },
  {
    orderID: 10956,
    customerID: "BLAUS",
    employeeID: 6,
    orderDate: "1998-03-17 00:00:00.000",
    requiredDate: "1998-04-28 00:00:00.000",
    shippedDate: "1998-03-20 00:00:00.000",
    shipVia: 2,
    freight: 44.65,
    shipName: "Blauer See Delikatessen",
    shipAddress: "Forsterstr. 57",
    shipCity: "Mannheim",
    shipRegion: "NULL",
    shipPostalCode: 68306,
    shipCountry: "Germany",
  },
  {
    orderID: 10957,
    customerID: "HILAA",
    employeeID: 8,
    orderDate: "1998-03-18 00:00:00.000",
    requiredDate: "1998-04-15 00:00:00.000",
    shippedDate: "1998-03-27 00:00:00.000",
    shipVia: 3,
    freight: 105.36,
    shipName: "HILARION-Abastos",
    shipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
    shipCity: "San Cristóbal",
    shipRegion: "Táchira",
    shipPostalCode: 5022,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10958,
    customerID: "OCEAN",
    employeeID: 7,
    orderDate: "1998-03-18 00:00:00.000",
    requiredDate: "1998-04-15 00:00:00.000",
    shippedDate: "1998-03-27 00:00:00.000",
    shipVia: 2,
    freight: 49.56,
    shipName: "Océano Atlántico Ltda.",
    shipAddress: "Ing. Gustavo Moncada 8585 Piso 20-A",
    shipCity: "Buenos Aires",
    shipRegion: "NULL",
    shipPostalCode: 1010,
    shipCountry: "Argentina",
  },
  {
    orderID: 10959,
    customerID: "GOURL",
    employeeID: 6,
    orderDate: "1998-03-18 00:00:00.000",
    requiredDate: "1998-04-29 00:00:00.000",
    shippedDate: "1998-03-23 00:00:00.000",
    shipVia: 2,
    freight: 4.98,
    shipName: "Gourmet Lanchonetes",
    shipAddress: "Av. Brasil 442",
    shipCity: "Campinas",
    shipRegion: "SP",
    shipPostalCode: "04876-786",
    shipCountry: "Brazil",
  },
  {
    orderID: 10960,
    customerID: "HILAA",
    employeeID: 3,
    orderDate: "1998-03-19 00:00:00.000",
    requiredDate: "1998-04-02 00:00:00.000",
    shippedDate: "1998-04-08 00:00:00.000",
    shipVia: 1,
    freight: 2.08,
    shipName: "HILARION-Abastos",
    shipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
    shipCity: "San Cristóbal",
    shipRegion: "Táchira",
    shipPostalCode: 5022,
    shipCountry: "Venezuela",
  },
  {
    orderID: 10961,
    customerID: "QUEEN",
    employeeID: 8,
    orderDate: "1998-03-19 00:00:00.000",
    requiredDate: "1998-04-16 00:00:00.000",
    shippedDate: "1998-03-30 00:00:00.000",
    shipVia: 1,
    freight: 104.47,
    shipName: "Queen Cozinha",
    shipAddress: "Alameda dos Canàrios 891",
    shipCity: "Sao Paulo",
    shipRegion: "SP",
    shipPostalCode: "05487-020",
    shipCountry: "Brazil",
  },
];
const products = [
  {
    productID: 1,
    productName: "Chai",
    supplierID: 1,
    categoryID: 1,
    quantityPerUnit: "10 boxes x 20 bags",
    unitPrice: 18,
    unitsInStock: 39,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 2,
    productName: "Chang",
    supplierID: 1,
    categoryID: 1,
    quantityPerUnit: "24 - 12 oz bottles",
    unitPrice: 19,
    unitsInStock: 17,
    unitsOnOrder: 40,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 3,
    productName: "Aniseed Syrup",
    supplierID: 1,
    categoryID: 2,
    quantityPerUnit: "12 - 550 ml bottles",
    unitPrice: 10,
    unitsInStock: 13,
    unitsOnOrder: 70,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 4,
    productName: "Chef Anton's Cajun Seasoning",
    supplierID: 2,
    categoryID: 2,
    quantityPerUnit: "48 - 6 oz jars",
    unitPrice: 22,
    unitsInStock: 53,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 5,
    productName: "Chef Anton's Gumbo Mix",
    supplierID: 2,
    categoryID: 2,
    quantityPerUnit: "36 boxes",
    unitPrice: 21.35,
    unitsInStock: 0,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 6,
    productName: "Grandma's Boysenberry Spread",
    supplierID: 3,
    categoryID: 2,
    quantityPerUnit: "12 - 8 oz jars",
    unitPrice: 25,
    unitsInStock: 120,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 7,
    productName: "Uncle Bob's Organic Dried Pears",
    supplierID: 3,
    categoryID: 7,
    quantityPerUnit: "12 - 1 lb pkgs.",
    unitPrice: 30,
    unitsInStock: 15,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 8,
    productName: "Northwoods Cranberry Sauce",
    supplierID: 3,
    categoryID: 2,
    quantityPerUnit: "12 - 12 oz jars",
    unitPrice: 40,
    unitsInStock: 6,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 9,
    productName: "Mishi Kobe Niku",
    supplierID: 4,
    categoryID: 6,
    quantityPerUnit: "18 - 500 g pkgs.",
    unitPrice: 97,
    unitsInStock: 29,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 10,
    productName: "Ikura",
    supplierID: 4,
    categoryID: 8,
    quantityPerUnit: "12 - 200 ml jars",
    unitPrice: 31,
    unitsInStock: 31,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 11,
    productName: "Queso Cabrales",
    supplierID: 5,
    categoryID: 4,
    quantityPerUnit: "1 kg pkg.",
    unitPrice: 21,
    unitsInStock: 22,
    unitsOnOrder: 30,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 12,
    productName: "Queso Manchego La Pastora",
    supplierID: 5,
    categoryID: 4,
    quantityPerUnit: "10 - 500 g pkgs.",
    unitPrice: 38,
    unitsInStock: 86,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 13,
    productName: "Konbu",
    supplierID: 6,
    categoryID: 8,
    quantityPerUnit: "2 kg box",
    unitPrice: 6,
    unitsInStock: 24,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 14,
    productName: "Tofu",
    supplierID: 6,
    categoryID: 7,
    quantityPerUnit: "40 - 100 g pkgs.",
    unitPrice: 23.25,
    unitsInStock: 35,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 15,
    productName: "Genen Shouyu",
    supplierID: 6,
    categoryID: 2,
    quantityPerUnit: "24 - 250 ml bottles",
    unitPrice: 15.5,
    unitsInStock: 39,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 16,
    productName: "Pavlova",
    supplierID: 7,
    categoryID: 3,
    quantityPerUnit: "32 - 500 g boxes",
    unitPrice: 17.45,
    unitsInStock: 29,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 17,
    productName: "Alice Mutton",
    supplierID: 7,
    categoryID: 6,
    quantityPerUnit: "20 - 1 kg tins",
    unitPrice: 39,
    unitsInStock: 0,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 18,
    productName: "Carnarvon Tigers",
    supplierID: 7,
    categoryID: 8,
    quantityPerUnit: "16 kg pkg.",
    unitPrice: 62.5,
    unitsInStock: 42,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 19,
    productName: "Teatime Chocolate Biscuits",
    supplierID: 8,
    categoryID: 3,
    quantityPerUnit: "10 boxes x 12 pieces",
    unitPrice: 9.2,
    unitsInStock: 25,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 20,
    productName: "Sir Rodney's Marmalade",
    supplierID: 8,
    categoryID: 3,
    quantityPerUnit: "30 gift boxes",
    unitPrice: 81,
    unitsInStock: 40,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 21,
    productName: "Sir Rodney's Scones",
    supplierID: 8,
    categoryID: 3,
    quantityPerUnit: "24 pkgs. x 4 pieces",
    unitPrice: 10,
    unitsInStock: 3,
    unitsOnOrder: 40,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 22,
    productName: "Gustaf's Knäckebröd",
    supplierID: 9,
    categoryID: 5,
    quantityPerUnit: "24 - 500 g pkgs.",
    unitPrice: 21,
    unitsInStock: 104,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 23,
    productName: "Tunnbröd",
    supplierID: 9,
    categoryID: 5,
    quantityPerUnit: "12 - 250 g pkgs.",
    unitPrice: 9,
    unitsInStock: 61,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 24,
    productName: "Guaraná Fantástica",
    supplierID: 10,
    categoryID: 1,
    quantityPerUnit: "12 - 355 ml cans",
    unitPrice: 4.5,
    unitsInStock: 20,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 25,
    productName: "NuNuCa Nuß-Nougat-Creme",
    supplierID: 11,
    categoryID: 3,
    quantityPerUnit: "20 - 450 g glasses",
    unitPrice: 14,
    unitsInStock: 76,
    unitsOnOrder: 0,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 26,
    productName: "Gumbär Gummibärchen",
    supplierID: 11,
    categoryID: 3,
    quantityPerUnit: "100 - 250 g bags",
    unitPrice: 31.23,
    unitsInStock: 15,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 27,
    productName: "Schoggi Schokolade",
    supplierID: 11,
    categoryID: 3,
    quantityPerUnit: "100 - 100 g pieces",
    unitPrice: 43.9,
    unitsInStock: 49,
    unitsOnOrder: 0,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 28,
    productName: "Rössle Sauerkraut",
    supplierID: 12,
    categoryID: 7,
    quantityPerUnit: "25 - 825 g cans",
    unitPrice: 45.6,
    unitsInStock: 26,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 29,
    productName: "Thüringer Rostbratwurst",
    supplierID: 12,
    categoryID: 6,
    quantityPerUnit: "50 bags x 30 sausgs.",
    unitPrice: 123.79,
    unitsInStock: 0,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 30,
    productName: "Nord-Ost Matjeshering",
    supplierID: 13,
    categoryID: 8,
    quantityPerUnit: "10 - 200 g glasses",
    unitPrice: 25.89,
    unitsInStock: 10,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 31,
    productName: "Gorgonzola Telino",
    supplierID: 14,
    categoryID: 4,
    quantityPerUnit: "12 - 100 g pkgs",
    unitPrice: 12.5,
    unitsInStock: 0,
    unitsOnOrder: 70,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 32,
    productName: "Mascarpone Fabioli",
    supplierID: 14,
    categoryID: 4,
    quantityPerUnit: "24 - 200 g pkgs.",
    unitPrice: 32,
    unitsInStock: 9,
    unitsOnOrder: 40,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 33,
    productName: "Geitost",
    supplierID: 15,
    categoryID: 4,
    quantityPerUnit: "500 g",
    unitPrice: 2.5,
    unitsInStock: 112,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 34,
    productName: "Sasquatch Ale",
    supplierID: 16,
    categoryID: 1,
    quantityPerUnit: "24 - 12 oz bottles",
    unitPrice: 14,
    unitsInStock: 111,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 35,
    productName: "Steeleye Stout",
    supplierID: 16,
    categoryID: 1,
    quantityPerUnit: "24 - 12 oz bottles",
    unitPrice: 18,
    unitsInStock: 20,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 36,
    productName: "Inlagd Sill",
    supplierID: 17,
    categoryID: 8,
    quantityPerUnit: "24 - 250 g  jars",
    unitPrice: 19,
    unitsInStock: 112,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 37,
    productName: "Gravad lax",
    supplierID: 17,
    categoryID: 8,
    quantityPerUnit: "12 - 500 g pkgs.",
    unitPrice: 26,
    unitsInStock: 11,
    unitsOnOrder: 50,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 38,
    productName: "Côte de Blaye",
    supplierID: 18,
    categoryID: 1,
    quantityPerUnit: "12 - 75 cl bottles",
    unitPrice: 263.5,
    unitsInStock: 17,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 39,
    productName: "Chartreuse verte",
    supplierID: 18,
    categoryID: 1,
    quantityPerUnit: "750 cc per bottle",
    unitPrice: 18,
    unitsInStock: 69,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 40,
    productName: "Boston Crab Meat",
    supplierID: 19,
    categoryID: 8,
    quantityPerUnit: "24 - 4 oz tins",
    unitPrice: 18.4,
    unitsInStock: 123,
    unitsOnOrder: 0,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 41,
    productName: "Jack's New England Clam Chowder",
    supplierID: 19,
    categoryID: 8,
    quantityPerUnit: "12 - 12 oz cans",
    unitPrice: 9.65,
    unitsInStock: 85,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 42,
    productName: "Singaporean Hokkien Fried Mee",
    supplierID: 20,
    categoryID: 5,
    quantityPerUnit: "32 - 1 kg pkgs.",
    unitPrice: 14,
    unitsInStock: 26,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 43,
    productName: "Ipoh Coffee",
    supplierID: 20,
    categoryID: 1,
    quantityPerUnit: "16 - 500 g tins",
    unitPrice: 46,
    unitsInStock: 17,
    unitsOnOrder: 10,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 44,
    productName: "Gula Malacca",
    supplierID: 20,
    categoryID: 2,
    quantityPerUnit: "20 - 2 kg bags",
    unitPrice: 19.45,
    unitsInStock: 27,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 45,
    productName: "Rogede sild",
    supplierID: 21,
    categoryID: 8,
    quantityPerUnit: "1k pkg.",
    unitPrice: 9.5,
    unitsInStock: 5,
    unitsOnOrder: 70,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 46,
    productName: "Spegesild",
    supplierID: 21,
    categoryID: 8,
    quantityPerUnit: "4 - 450 g glasses",
    unitPrice: 12,
    unitsInStock: 95,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 47,
    productName: "Zaanse koeken",
    supplierID: 22,
    categoryID: 3,
    quantityPerUnit: "10 - 4 oz boxes",
    unitPrice: 9.5,
    unitsInStock: 36,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 48,
    productName: "Chocolade",
    supplierID: 22,
    categoryID: 3,
    quantityPerUnit: "10 pkgs.",
    unitPrice: 12.75,
    unitsInStock: 15,
    unitsOnOrder: 70,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 49,
    productName: "Maxilaku",
    supplierID: 23,
    categoryID: 3,
    quantityPerUnit: "24 - 50 g pkgs.",
    unitPrice: 20,
    unitsInStock: 10,
    unitsOnOrder: 60,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 50,
    productName: "Valkoinen suklaa",
    supplierID: 23,
    categoryID: 3,
    quantityPerUnit: "12 - 100 g bars",
    unitPrice: 16.25,
    unitsInStock: 65,
    unitsOnOrder: 0,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 51,
    productName: "Manjimup Dried Apples",
    supplierID: 24,
    categoryID: 7,
    quantityPerUnit: "50 - 300 g pkgs.",
    unitPrice: 53,
    unitsInStock: 20,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 52,
    productName: "Filo Mix",
    supplierID: 24,
    categoryID: 5,
    quantityPerUnit: "16 - 2 kg boxes",
    unitPrice: 7,
    unitsInStock: 38,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 53,
    productName: "Perth Pasties",
    supplierID: 24,
    categoryID: 6,
    quantityPerUnit: "48 pieces",
    unitPrice: 32.8,
    unitsInStock: 0,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 1,
  },
  {
    productID: 54,
    productName: "Tourtière",
    supplierID: 25,
    categoryID: 6,
    quantityPerUnit: "16 pies",
    unitPrice: 7.45,
    unitsInStock: 21,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 55,
    productName: "Pâté chinois",
    supplierID: 25,
    categoryID: 6,
    quantityPerUnit: "24 boxes x 2 pies",
    unitPrice: 24,
    unitsInStock: 115,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 56,
    productName: "Gnocchi di nonna Alice",
    supplierID: 26,
    categoryID: 5,
    quantityPerUnit: "24 - 250 g pkgs.",
    unitPrice: 38,
    unitsInStock: 21,
    unitsOnOrder: 10,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 57,
    productName: "Ravioli Angelo",
    supplierID: 26,
    categoryID: 5,
    quantityPerUnit: "24 - 250 g pkgs.",
    unitPrice: 19.5,
    unitsInStock: 36,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 58,
    productName: "Escargots de Bourgogne",
    supplierID: 27,
    categoryID: 8,
    quantityPerUnit: "24 pieces",
    unitPrice: 13.25,
    unitsInStock: 62,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 59,
    productName: "Raclette Courdavault",
    supplierID: 28,
    categoryID: 4,
    quantityPerUnit: "5 kg pkg.",
    unitPrice: 55,
    unitsInStock: 79,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 60,
    productName: "Camembert Pierrot",
    supplierID: 28,
    categoryID: 4,
    quantityPerUnit: "15 - 300 g rounds",
    unitPrice: 34,
    unitsInStock: 19,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 61,
    productName: "Sirop d'érable",
    supplierID: 29,
    categoryID: 2,
    quantityPerUnit: "24 - 500 ml bottles",
    unitPrice: 28.5,
    unitsInStock: 113,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 62,
    productName: "Tarte au sucre",
    supplierID: 29,
    categoryID: 3,
    quantityPerUnit: "48 pies",
    unitPrice: 49.3,
    unitsInStock: 17,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 63,
    productName: "Vegie-spread",
    supplierID: 7,
    categoryID: 2,
    quantityPerUnit: "15 - 625 g jars",
    unitPrice: 43.9,
    unitsInStock: 24,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 64,
    productName: "Wimmers gute Semmelknödel",
    supplierID: 12,
    categoryID: 5,
    quantityPerUnit: "20 bags x 4 pieces",
    unitPrice: 33.25,
    unitsInStock: 22,
    unitsOnOrder: 80,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 65,
    productName: "Louisiana Fiery Hot Pepper Sauce",
    supplierID: 2,
    categoryID: 2,
    quantityPerUnit: "32 - 8 oz bottles",
    unitPrice: 21.05,
    unitsInStock: 76,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 66,
    productName: "Louisiana Hot Spiced Okra",
    supplierID: 2,
    categoryID: 2,
    quantityPerUnit: "24 - 8 oz jars",
    unitPrice: 17,
    unitsInStock: 4,
    unitsOnOrder: 100,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 67,
    productName: "Laughing Lumberjack Lager",
    supplierID: 16,
    categoryID: 1,
    quantityPerUnit: "24 - 12 oz bottles",
    unitPrice: 14,
    unitsInStock: 52,
    unitsOnOrder: 0,
    reorderLevel: 10,
    discontinued: 0,
  },
  {
    productID: 68,
    productName: "Scottish Longbreads",
    supplierID: 8,
    categoryID: 3,
    quantityPerUnit: "10 boxes x 8 pieces",
    unitPrice: 12.5,
    unitsInStock: 6,
    unitsOnOrder: 10,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 69,
    productName: "Gudbrandsdalsost",
    supplierID: 15,
    categoryID: 4,
    quantityPerUnit: "10 kg pkg.",
    unitPrice: 36,
    unitsInStock: 26,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
  {
    productID: 70,
    productName: "Outback Lager",
    supplierID: 7,
    categoryID: 1,
    quantityPerUnit: "24 - 355 ml bottles",
    unitPrice: 15,
    unitsInStock: 15,
    unitsOnOrder: 10,
    reorderLevel: 30,
    discontinued: 0,
  },
  {
    productID: 71,
    productName: "Flotemysost",
    supplierID: 15,
    categoryID: 4,
    quantityPerUnit: "10 - 500 g pkgs.",
    unitPrice: 21.5,
    unitsInStock: 26,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 72,
    productName: "Mozzarella di Giovanni",
    supplierID: 14,
    categoryID: 4,
    quantityPerUnit: "24 - 200 g pkgs.",
    unitPrice: 34.8,
    unitsInStock: 14,
    unitsOnOrder: 0,
    reorderLevel: 0,
    discontinued: 0,
  },
  {
    productID: 73,
    productName: "Röd Kaviar",
    supplierID: 17,
    categoryID: 8,
    quantityPerUnit: "24 - 150 g jars",
    unitPrice: 15,
    unitsInStock: 101,
    unitsOnOrder: 0,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 74,
    productName: "Longlife Tofu",
    supplierID: 4,
    categoryID: 7,
    quantityPerUnit: "5 kg pkg.",
    unitPrice: 10,
    unitsInStock: 4,
    unitsOnOrder: 20,
    reorderLevel: 5,
    discontinued: 0,
  },
  {
    productID: 75,
    productName: "Rhönbräu Klosterbier",
    supplierID: 12,
    categoryID: 1,
    quantityPerUnit: "24 - 0.5 l bottles",
    unitPrice: 7.75,
    unitsInStock: 125,
    unitsOnOrder: 0,
    reorderLevel: 25,
    discontinued: 0,
  },
  {
    productID: 76,
    productName: "Lakkalikööri",
    supplierID: 23,
    categoryID: 1,
    quantityPerUnit: "500 ml",
    unitPrice: 18,
    unitsInStock: 57,
    unitsOnOrder: 0,
    reorderLevel: 20,
    discontinued: 0,
  },
  {
    productID: 77,
    productName: "Original Frankfurter grüne Soße",
    supplierID: 12,
    categoryID: 2,
    quantityPerUnit: "12 boxes",
    unitPrice: 13,
    unitsInStock: 32,
    unitsOnOrder: 0,
    reorderLevel: 15,
    discontinued: 0,
  },
];
const regions = [
  {
    regionID: 1,
    regionDescription: "Eastern",
  },
  {
    regionID: 2,
    regionDescription: "Western",
  },
  {
    regionID: 3,
    regionDescription: "Northern",
  },
  {
    regionID: 4,
    regionDescription: "Southern",
  },
];
const suppliers = [
  {
    supplierID: 1,
    companyName: "Exotic Liquids",
    contactName: "Charlotte Cooper",
    contactTitle: "Purchasing Manager",
    address: "49 Gilbert St.",
    city: "London",
    region: "NULL",
    postalCode: "EC1 4SD",
    country: "UK",
    phone: "(171) 555-2222",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 2,
    companyName: "New Orleans Cajun Delights",
    contactName: "Shelley Burke",
    contactTitle: "Order Administrator",
    address: "P.O. Box 78934",
    city: "New Orleans",
    region: "LA",
    postalCode: 70117,
    country: "USA",
    phone: "(100) 555-4822",
    fax: "NULL",
    homePage: "#CAJUN.HTM#",
  },
  {
    supplierID: 3,
    companyName: "Grandma Kelly's Homestead",
    contactName: "Regina Murphy",
    contactTitle: "Sales Representative",
    address: "707 Oxford Rd.",
    city: "Ann Arbor",
    region: "MI",
    postalCode: 48104,
    country: "USA",
    phone: "(313) 555-5735",
    fax: "(313) 555-3349",
    homePage: "NULL",
  },
  {
    supplierID: 4,
    companyName: "Tokyo Traders",
    contactName: "Yoshi Nagase",
    contactTitle: "Marketing Manager",
    address: "9-8 Sekimai Musashino-shi",
    city: "Tokyo",
    region: "NULL",
    postalCode: 100,
    country: "Japan",
    phone: "(03) 3555-5011",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 5,
    companyName: "Cooperativa de Quesos 'Las Cabras'",
    contactName: "Antonio del Valle Saavedra",
    contactTitle: "Export Administrator",
    address: "Calle del Rosal 4",
    city: "Oviedo",
    region: "Asturias",
    postalCode: 33007,
    country: "Spain",
    phone: "(98) 598 76 54",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 6,
    companyName: "Mayumi's",
    contactName: "Mayumi Ohno",
    contactTitle: "Marketing Representative",
    address: "92 Setsuko Chuo-ku",
    city: "Osaka",
    region: "NULL",
    postalCode: 545,
    country: "Japan",
    phone: "(06) 431-7877",
    fax: "NULL",
    homePage:
      "Mayumi's (on the World Wide Web)#http://www.microsoft.com/accessdev/sampleapps/mayumi.htm#",
  },
  {
    supplierID: 7,
    companyName: "Pavlova Ltd.",
    contactName: "Ian Devling",
    contactTitle: "Marketing Manager",
    address: "74 Rose St. Moonie Ponds",
    city: "Melbourne",
    region: "Victoria",
    postalCode: 3058,
    country: "Australia",
    phone: "(03) 444-2343",
    fax: "(03) 444-6588",
    homePage: "NULL",
  },
  {
    supplierID: 8,
    companyName: "Specialty Biscuits Ltd.",
    contactName: "Peter Wilson",
    contactTitle: "Sales Representative",
    address: "29 King's Way",
    city: "Manchester",
    region: "NULL",
    postalCode: "M14 GSD",
    country: "UK",
    phone: "(161) 555-4448",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 9,
    companyName: "PB Knäckebröd AB",
    contactName: "Lars Peterson",
    contactTitle: "Sales Agent",
    address: "Kaloadagatan 13",
    city: "Göteborg",
    region: "NULL",
    postalCode: "S-345 67",
    country: "Sweden",
    phone: "031-987 65 43",
    fax: "031-987 65 91",
    homePage: "NULL",
  },
  {
    supplierID: 10,
    companyName: "Refrescos Americanas LTDA",
    contactName: "Carlos Diaz",
    contactTitle: "Marketing Manager",
    address: "Av. das Americanas 12.890",
    city: "Sao Paulo",
    region: "NULL",
    postalCode: 5442,
    country: "Brazil",
    phone: "(11) 555 4640",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 11,
    companyName: "Heli Süßwaren GmbH & Co. KG",
    contactName: "Petra Winkler",
    contactTitle: "Sales Manager",
    address: "Tiergartenstraße 5",
    city: "Berlin",
    region: "NULL",
    postalCode: 10785,
    country: "Germany",
    phone: "(010) 9984510",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 12,
    companyName: "Plutzer Lebensmittelgroßmärkte AG",
    contactName: "Martin Bein",
    contactTitle: "International Marketing Mgr.",
    address: "Bogenallee 51",
    city: "Frankfurt",
    region: "NULL",
    postalCode: 60439,
    country: "Germany",
    phone: "(069) 992755",
    fax: "NULL",
    homePage:
      "Plutzer (on the World Wide Web)#http://www.microsoft.com/accessdev/sampleapps/plutzer.htm#",
  },
  {
    supplierID: 13,
    companyName: "Nord-Ost-Fisch Handelsgesellschaft mbH",
    contactName: "Sven Petersen",
    contactTitle: "Coordinator Foreign Markets",
    address: "Frahmredder 112a",
    city: "Cuxhaven",
    region: "NULL",
    postalCode: 27478,
    country: "Germany",
    phone: "(04721) 8713",
    fax: "(04721) 8714",
    homePage: "NULL",
  },
  {
    supplierID: 14,
    companyName: "Formaggi Fortini s.r.l.",
    contactName: "Elio Rossi",
    contactTitle: "Sales Representative",
    address: "Viale Dante 75",
    city: "Ravenna",
    region: "NULL",
    postalCode: 48100,
    country: "Italy",
    phone: "(0544) 60323",
    fax: "(0544) 60603",
    homePage: "#FORMAGGI.HTM#",
  },
  {
    supplierID: 15,
    companyName: "Norske Meierier",
    contactName: "Beate Vileid",
    contactTitle: "Marketing Manager",
    address: "Hatlevegen 5",
    city: "Sandvika",
    region: "NULL",
    postalCode: 1320,
    country: "Norway",
    phone: "(0)2-953010",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 16,
    companyName: "Bigfoot Breweries",
    contactName: "Cheryl Saylor",
    contactTitle: "Regional Account Rep.",
    address: "3400 - 8th Avenue Suite 210",
    city: "Bend",
    region: "OR",
    postalCode: 97101,
    country: "USA",
    phone: "(503) 555-9931",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 17,
    companyName: "Svensk Sjöföda AB",
    contactName: "Michael Björn",
    contactTitle: "Sales Representative",
    address: "Brovallavägen 231",
    city: "Stockholm",
    region: "NULL",
    postalCode: "S-123 45",
    country: "Sweden",
    phone: "08-123 45 67",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 18,
    companyName: "Aux joyeux ecclésiastiques",
    contactName: "Guylène Nodier",
    contactTitle: "Sales Manager",
    address: "203 Rue des Francs-Bourgeois",
    city: "Paris",
    region: "NULL",
    postalCode: 75004,
    country: "France",
    phone: "(1) 03.83.00.68",
    fax: "(1) 03.83.00.62",
    homePage: "NULL",
  },
  {
    supplierID: 19,
    companyName: "New England Seafood Cannery",
    contactName: "Robb Merchant",
    contactTitle: "Wholesale Account Agent",
    address: "Order Processing Dept. 2100 Paul Revere Blvd.",
    city: "Boston",
    region: "MA",
    postalCode: "02134",
    country: "USA",
    phone: "(617) 555-3267",
    fax: "(617) 555-3389",
    homePage: "NULL",
  },
  {
    supplierID: 20,
    companyName: "Leka Trading",
    contactName: "Chandra Leka",
    contactTitle: "Owner",
    address: "471 Serangoon Loop Suite #402",
    city: "Singapore",
    region: "NULL",
    postalCode: "0512",
    country: "Singapore",
    phone: "555-8787",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 21,
    companyName: "Lyngbysild",
    contactName: "Niels Petersen",
    contactTitle: "Sales Manager",
    address: "Lyngbysild Fiskebakken 10",
    city: "Lyngby",
    region: "NULL",
    postalCode: 2800,
    country: "Denmark",
    phone: 43844108,
    fax: 43844115,
    homePage: "NULL",
  },
  {
    supplierID: 22,
    companyName: "Zaanse Snoepfabriek",
    contactName: "Dirk Luchte",
    contactTitle: "Accounting Manager",
    address: "Verkoop Rijnweg 22",
    city: "Zaandam",
    region: "NULL",
    postalCode: "9999 ZZ",
    country: "Netherlands",
    phone: "(12345) 1212",
    fax: "(12345) 1210",
    homePage: "NULL",
  },
  {
    supplierID: 23,
    companyName: "Karkki Oy",
    contactName: "Anne Heikkonen",
    contactTitle: "Product Manager",
    address: "Valtakatu 12",
    city: "Lappeenranta",
    region: "NULL",
    postalCode: 53120,
    country: "Finland",
    phone: "(953) 10956",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 24,
    companyName: "G'day Mate",
    contactName: "Wendy Mackenzie",
    contactTitle: "Sales Representative",
    address: "170 Prince Edward Parade Hunter's Hill",
    city: "Sydney",
    region: "NSW",
    postalCode: 2042,
    country: "Australia",
    phone: "(02) 555-5914",
    fax: "(02) 555-4873",
    homePage:
      "G'day Mate (on the World Wide Web)#http://www.microsoft.com/accessdev/sampleapps/gdaymate.htm#",
  },
  {
    supplierID: 25,
    companyName: "Ma Maison",
    contactName: "Jean-Guy Lauzon",
    contactTitle: "Marketing Manager",
    address: "2960 Rue St. Laurent",
    city: "Montréal",
    region: "Québec",
    postalCode: "H1J 1C3",
    country: "Canada",
    phone: "(514) 555-9022",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 26,
    companyName: "Pasta Buttini s.r.l.",
    contactName: "Giovanni Giudici",
    contactTitle: "Order Administrator",
    address: "Via dei Gelsomini 153",
    city: "Salerno",
    region: "NULL",
    postalCode: 84100,
    country: "Italy",
    phone: "(089) 6547665",
    fax: "(089) 6547667",
    homePage: "NULL",
  },
  {
    supplierID: 27,
    companyName: "Escargots Nouveaux",
    contactName: "Marie Delamare",
    contactTitle: "Sales Manager",
    address: "22 rue H. Voiron",
    city: "Montceau",
    region: "NULL",
    postalCode: 71300,
    country: "France",
    phone: "85.57.00.07",
    fax: "NULL",
    homePage: "NULL",
  },
  {
    supplierID: 28,
    companyName: "Gai pâturage",
    contactName: "Eliane Noz",
    contactTitle: "Sales Representative",
    address: "Bat. B 3 rue des Alpes",
    city: "Annecy",
    region: "NULL",
    postalCode: 74000,
    country: "France",
    phone: "38.76.98.06",
    fax: "38.76.98.58",
    homePage: "NULL",
  },
  {
    supplierID: 29,
    companyName: "Forêts d'érables",
    contactName: "Chantal Goulet",
    contactTitle: "Accounting Manager",
    address: "148 rue Chasseur",
    city: "Ste-Hyacinthe",
    region: "Québec",
    postalCode: "J2S 7S8",
    country: "Canada",
    phone: "(514) 555-2955",
    fax: "(514) 555-2921",
    homePage: "NULL",
  },
];

const data = {
  categories,
  customers,
  employees,
  order_details,
  orders,
  products,
  regions,
  suppliers,
};
export default data;
